export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';

export const LOAD_TASKS_SUCCESS = 'LOAD_TASKS_SUCCESS';

// Account Actions
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const VERIFY_REQUEST = 'VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAILURE = 'VERIFY_FAILURE';
export const POSTSSO_LOGIN_REQUEST = 'POSTSSO_LOGIN_REQUEST';
export const POSTSSO_LOGIN_SUCCESS = 'POSTSSO_LOGIN_SUCCESS';
export const POSTSSO_LOGIN_FAILURE = 'POSTSSO_LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE';
export const FORGOT_USERNAME_REQUEST = 'FORGOT_USERNAME_REQUEST';
export const FORGOT_USERNAME_SUCCESS = 'FORGOT_USERNAME_SUCCESS';
export const FORGOT_USERNAME_FAILURE = 'FORGOT_USERNAME_FAILURE';
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export const GET_USERNAME_REQUEST = 'GET_USERNAME_REQUEST';
export const GET_USERNAME_SUCCESS = 'GET_USERNAME_SUCCESS';
export const GET_USERNAME_FAILURE = 'GET_USERNAME_FAILURE';
export const SET_CURRENT_SUBSCRIPTION = 'SET_CURRENT_SUBSCRIPTION';
export const CHECK_RESET_TOKEN_REQUEST = 'CHECK_RESET_TOKEN_REQUEST';
export const CHECK_RESET_TOKEN_SUCCESS = 'CHECK_RESET_TOKEN_SUCCESS';
export const CHECK_RESET_TOKEN_FAILURE = 'CHECK_RESET_TOKEN_FAILURE';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const CLEAR_LOGIN_WORKFLOW = 'CLEAR_LOGIN_WORKFLOW';
export const COMPLETE_WORKFLOW_STEP = 'COMPLETE_WORKFLOW_STEP';
export const SET_ACTIVE_USER_SUBSCRIPTIONS = 'SET_ACTIVE_USER_SUBSCRIPTIONS';
export const SET_SSO_TEMP_TOKEN = 'SET_SSO_TEMP_TOKEN';
export const GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_REQUEST = 'GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_REQUEST';
export const GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_SUCCESS = 'GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_SUCCESS';
export const GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_FAILURE = 'GET_SUBSCRIPTION_DEPENDENT_WORKFLOW_STEPS_FAILURE';
export const GET_DEBUG_SETTINGS_REQUEST = 'GET_DEBUG_SETTINGS_REQUEST';
export const GET_DEBUG_SETTINGS_SUCCESS = 'GET_DEBUG_SETTINGS_SUCCESS';
export const GET_DEBUG_SETTINGS_FAILURE = 'GET_DEBUG_SETTINGS_FAILURE';
export const FREE_TRIAL_SIGN_UP_REQUEST = 'FREE_TRIAL_SIGN_UP_REQUEST';
export const FREE_TRIAL_SIGN_UP_SUCCESS = 'FREE_TRIAL_SIGN_UP_SUCCESS';
export const FREE_TRIAL_SIGN_UP_FAILURE = 'FREE_TRIAL_SIGN_UP_FAILURE';
export const LOAD_FREE_TRIAL_SIGN_UP_FILTERS_REQUEST = 'LOAD_FREE_TRIAL_SIGN_UP_FILTERS_REQUEST';
export const LOAD_FREE_TRIAL_SIGN_UP_FILTERS_SUCCESS = 'LOAD_FREE_TRIAL_SIGN_UP_FILTERS_SUCCESS';
export const LOAD_FREE_TRIAL_SIGN_UP_FILTERS_FAILURE = 'LOAD_FREE_TRIAL_SIGN_UP_FILTERS_FAILURE';

// Subscription Actions
export const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST';
export const GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS';
export const GET_SUBSCRIPTION_FAILURE = 'GET_SUBSCRIPTION_FAILURE';
export const GET_SUBSCRIPTION_FILTERS_REQUEST = 'GET_SUBSCRIPTION_FILTERS_REQUEST';
export const GET_SUBSCRIPTION_FILTERS_SUCCESS = 'GET_SUBSCRIPTION_FILTERS_SUCCESS';
export const GET_SUBSCRIPTION_FILTERS_FAILURE = 'GET_SUBSCRIPTION_FILTERS_FAILURE';
export const GET_SUBSCRIPTION_PROFILE_REQUEST = 'GET_SUBSCRIPTION_PROFILE_REQUEST';
export const GET_SUBSCRIPTION_PROFILE_SUCCESS = 'GET_SUBSCRIPTION_PROFILE_SUCCESS';
export const GET_SUBSCRIPTION_PROFILE_FAILURE = 'GET_SUBSCRIPTION_PROFILE_FAILURE';
export const LOAD_SUBSCRIPTIONS_REQUEST = 'LOAD_SUBSCRIPTIONS_REQUEST';
export const LOAD_SUBSCRIPTIONS_SUCCESS = 'LOAD_SUBSCRIPTIONS_SUCCESS';
export const LOAD_SUBSCRIPTIONS_FAILURE = 'LOAD_SUBSCRIPTIONS_FAILURE';
export const LIST_SUBSCRIPTIONS_REQUEST = 'LIST_SUBSCRIPTIONS_REQUEST';
export const LIST_SUBSCRIPTIONS_SUCCESS = 'LIST_SUBSCRIPTIONS_SUCCESS';
export const LIST_SUBSCRIPTIONS_FAILURE = 'LIST_SUBSCRIPTIONS_FAILURE';
export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';
export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_FAILURE = 'UPDATE_SUBSCRIPTION_FAILURE';
export const UPDATE_SUBSCRIPTION_PROFILE_REQUEST = 'UPDATE_SUBSCRIPTION_PROFILE_REQUEST';
export const UPDATE_SUBSCRIPTION_PROFILE_SUCCESS = 'UPDATE_SUBSCRIPTION_PROFILE_SUCCESS';
export const UPDATE_SUBSCRIPTION_PROFILE_FAILURE = 'UPDATE_SUBSCRIPTION_PROFILE_FAILURE';
export const GET_SUBSCRIPTION_INVITEMESSAGE_REQUEST = 'GET_SUBSCRIPTION_INVITEMESSAGE_REQUEST';
export const GET_SUBSCRIPTION_INVITEMESSAGE_SUCCESS = 'GET_SUBSCRIPTION_INVITEMESSAGE_SUCCESS';
export const GET_SUBSCRIPTION_INVITEMESSAGE_FAILURE = 'GET_SUBSCRIPTION_INVITEMESSAGE_FAILURE';
export const GET_SUBSCRIPTION_REPORT_FOOTER_REQUEST = 'GET_SUBSCRIPTION_REPORT_FOOTER_REQUEST';
export const GET_SUBSCRIPTION_REPORT_FOOTER_SUCCESS = 'GET_SUBSCRIPTION_REPORT_FOOTER_SUCCESS';
export const GET_SUBSCRIPTION_REPORT_FOOTER_FAILURE = 'GET_SUBSCRIPTION_REPORT_FOOTER_FAILURE';

// Discipline Actions
export const LIST_DISCIPLINE_REQUEST = 'LIST_DISCIPLINE_REQUEST';
export const LIST_DISCIPLINE_SUCCESS = 'LIST_DISCIPLINE_SUCCESS';
export const LIST_DISCIPLINE_FAILURE = 'LIST_DISCIPLINE_FAILURE';
export const SEARCH_DISCIPLINE_REQUEST = 'SEARCH_DISCIPLINE_REQUEST';
export const SEARCH_DISCIPLINE_SUCCESS = 'SEARCH_DISCIPLINE_SUCCESS';
export const SEARCH_DISCIPLINE_FAILURE = 'SEARCH_DISCIPLINE_FAILURE';
export const CREATE_DISCIPLINE_REQUEST = 'CREATE_DISCIPLINE_REQUEST';
export const CREATE_DISCIPLINE_SUCCESS = 'CREATE_DISCIPLINE_SUCCESS';
export const CREATE_DISCIPLINE_FAILURE = 'CREATE_DISCIPLINE_FAILURE';
export const UPDATE_DISCIPLINE_REQUEST = 'UPDATE_DISCIPLINE_REQUEST';
export const UPDATE_DISCIPLINE_SUCCESS = 'UPDATE_DISCIPLINE_SUCCESS';
export const UPDATE_DISCIPLINE_FAILURE = 'UPDATE_DISCIPLINE_FAILURE';

// Community Actions
export const SEARCH_COMMUNITY_REQUEST = 'SEARCH_COMMUNITY_REQUEST';
export const SEARCH_COMMUNITY_SUCCESS = 'SEARCH_COMMUNITY_SUCCESS';
export const SEARCH_COMMUNITY_FAILURE = 'SEARCH_COMMUNITY_FAILURE';
export const CREATE_COMMUNITY_REQUEST = 'CREATE_COMMUNITY_REQUEST';
export const CREATE_COMMUNITY_SUCCESS = 'CREATE_COMMUNITY_SUCCESS';
export const CREATE_COMMUNITY_FAILURE = 'CREATE_COMMUNITY_FAILURE';
export const UPDATE_COMMUNITY_REQUEST = 'UPDATE_COMMUNITY_REQUEST';
export const UPDATE_COMMUNITY_SUCCESS = 'UPDATE_COMMUNITY_SUCCESS';
export const UPDATE_COMMUNITY_FAILURE = 'UPDATE_COMMUNITY_FAILURE';

// Job Title Actions
export const SEARCH_JOB_TITLE_REQUEST = 'SEARCH_JOB_TITLE_REQUEST';
export const SEARCH_JOB_TITLE_SUCCESS = 'SEARCH_JOB_TITLE_SUCCESS';
export const SEARCH_JOB_TITLE_FAILURE = 'SEARCH_JOB_TITLE_FAILURE';
export const CREATE_JOB_TITLE_REQUEST = 'CREATE_JOB_TITLE_REQUEST';
export const CREATE_JOB_TITLE_SUCCESS = 'CREATE_JOB_TITLE_SUCCESS';
export const CREATE_JOB_TITLE_FAILURE = 'CREATE_JOB_TITLE_FAILURE';
export const UPDATE_JOB_TITLE_REQUEST = 'UPDATE_JOB_TITLE_REQUEST';
export const UPDATE_JOB_TITLE_SUCCESS = 'UPDATE_JOB_TITLE_SUCCESS';
export const UPDATE_JOB_TITLE_FAILURE = 'UPDATE_JOB_TITLE_FAILURE';

// Department Actions
export const SEARCH_DEPARTMENT_REQUEST = 'SEARCH_DEPARTMENT_REQUEST';
export const SEARCH_DEPARTMENT_SUCCESS = 'SEARCH_DEPARTMENT_SUCCESS';
export const SEARCH_DEPARTMENT_FAILURE = 'SEARCH_DEPARTMENT_FAILURE';
export const LOAD_DEPARTMENT_REQUEST = 'LOAD_DEPARTMENT_REQUEST';
export const LOAD_DEPARTMENT_SUCCESS = 'LOAD_DEPARTMENT_SUCCESS';
export const LOAD_DEPARTMENT_FAILURE = 'LOAD_DEPARTMENT_FAILURE';
export const CREATE_DEPARTMENT_REQUEST = 'CREATE_DEPARTMENT_REQUEST';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_FAILURE = 'CREATE_DEPARTMENT_FAILURE';
export const UPDATE_DEPARTMENT_REQUEST = 'UPDATE_DEPARTMENT_REQUEST';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_FAILURE = 'UPDATE_DEPARTMENT_FAILURE';

// LocationType Actions
export const SEARCH_LOCATIONTYPE_REQUEST = 'SEARCH_LOCATIONTYPE_REQUEST';
export const SEARCH_LOCATIONTYPE_SUCCESS = 'SEARCH_LOCATIONTYPE_SUCCESS';
export const SEARCH_LOCATIONTYPE_FAILURE = 'SEARCH_LOCATIONTYPE_FAILURE';
export const CREATE_LOCATIONTYPE_REQUEST = 'CREATE_LOCATIONTYPE_REQUEST';
export const CREATE_LOCATIONTYPE_SUCCESS = 'CREATE_LOCATIONTYPE_SUCCESS';
export const CREATE_LOCATIONTYPE_FAILURE = 'CREATE_LOCATIONTYPE_FAILURE';
export const UPDATE_LOCATIONTYPE_REQUEST = 'UPDATE_LOCATIONTYPE_REQUEST';
export const UPDATE_LOCATIONTYPE_SUCCESS = 'UPDATE_LOCATIONTYPE_SUCCESS';
export const UPDATE_LOCATIONTYPE_FAILURE = 'UPDATE_LOCATIONTYPE_FAILURE';

// LocationArea Actions
export const SEARCH_LOCATIONAREA_REQUEST = 'SEARCH_LOCATIONAREA_REQUEST';
export const SEARCH_LOCATIONAREA_SUCCESS = 'SEARCH_LOCATIONAREA_SUCCESS';
export const SEARCH_LOCATIONAREA_FAILURE = 'SEARCH_LOCATIONAREA_FAILURE';
export const CREATE_LOCATIONAREA_REQUEST = 'CREATE_LOCATIONAREA_REQUEST';
export const CREATE_LOCATIONAREA_SUCCESS = 'CREATE_LOCATIONAREA_SUCCESS';
export const CREATE_LOCATIONAREA_FAILURE = 'CREATE_LOCATIONAREA_FAILURE';
export const UPDATE_LOCATIONAREA_REQUEST = 'UPDATE_LOCATIONAREA_REQUEST';
export const UPDATE_LOCATIONAREA_SUCCESS = 'UPDATE_LOCATIONAREA_SUCCESS';
export const UPDATE_LOCATIONAREA_FAILURE = 'UPDATE_LOCATIONAREA_FAILURE';

// Location Contact Actions
export const SEARCH_LOCATION_CONTACTS_REQUEST = 'SEARCH_LOCATION_CONTACTS_REQUEST';
export const SEARCH_LOCATION_CONTACTS_SUCCESS = 'SEARCH_LOCATION_CONTACTS_SUCCESS';
export const SEARCH_LOCATION_CONTACTS_FAILURE = 'SEARCH_LOCATION_CONTACTS_FAILURE';
export const CREATE_LOCATION_CONTACT_REQUEST = 'CREATE_LOCATION_CONTACT_REQUEST';
export const CREATE_LOCATION_CONTACT_SUCCESS = 'CREATE_LOCATION_CONTACT_SUCCESS';
export const CREATE_LOCATION_CONTACT_FAILURE = 'CREATE_LOCATION_CONTACT_FAILURE';
export const REMOVE_LOCATION_CONTACT_REQUEST = 'REMOVE_LOCATION_CONTACT_REQUEST';
export const REMOVE_LOCATION_CONTACT_SUCCESS = 'REMOVE_LOCATION_CONTACT_SUCCESS';
export const REMOVE_LOCATION_CONTACT_FAILURE = 'REMOVE_LOCATION_CONTACT_FAILURE';
export const CONTACTS_TO_IMPORT_REQUEST = 'CONTACTS_TO_IMPORT_REQUEST';
export const CONTACTS_TO_IMPORT_SUCCESS = 'CONTACTS_TO_IMPORT_SUCCESS';
export const CONTACTS_TO_IMPORT_FAILURE = 'CONTACTS_TO_IMPORT_FAILURE';
export const IMPORT_CONTACTS_REQUEST = 'IMPORT_CONTACTS_REQUEST';
export const IMPORT_CONTACTS_SUCCESS = 'IMPORT_CONTACTS_SUCCESS';
export const IMPORT_CONTACTS_FAILURE = 'IMPORT_CONTACTS_FAILURE';

// management company Actions
export const SEARCH_MGMTCOMPANY_REQUEST = 'SEARCH_MGMTCOMPANY_REQUEST';
export const SEARCH_MGMTCOMPANY_SUCCESS = 'SEARCH_MGMTCOMPANY_SUCCESS';
export const SEARCH_MGMTCOMPANY_FAILURE = 'SEARCH_MGMTCOMPANY_FAILURE';
export const CREATE_MGMTCOMPANY_REQUEST = 'CREATE_MGMTCOMPANY_REQUEST';
export const CREATE_MGMTCOMPANY_SUCCESS = 'CREATE_MGMTCOMPANY_SUCCESS';
export const CREATE_MGMTCOMPANY_FAILURE = 'CREATE_MGMTCOMPANY_FAILURE';
export const UPDATE_MGMTCOMPANY_REQUEST = 'UPDATE_MGMTCOMPANY_REQUEST';
export const UPDATE_MGMTCOMPANY_SUCCESS = 'UPDATE_MGMTCOMPANY_SUCCESS';
export const UPDATE_MGMTCOMPANY_FAILURE = 'UPDATE_MGMTCOMPANY_FAILURE';

// Admin Actions
export const LOAD_ADMIN_REQUEST = 'LOAD_ADMIN_REQUEST';
export const LOAD_ADMIN_SUCCESS = 'LOAD_ADMIN_SUCCESS';
export const LOAD_ADMIN_FAILURE = 'LOAD_ADMIN_FAILURE';
export const LOAD_ADMIN_FILTERS_REQUEST = 'LOAD_ADMIN_FILTERS_REQUEST';
export const LOAD_ADMIN_FILTERS_SUCCESS = 'LOAD_ADMIN_FILTERS_SUCCESS';
export const LOAD_ADMIN_FILTERS_FAILURE = 'LOAD_ADMIN_FILTERS_FAILURE';
export const LOAD_ADMIN_USERS_REQUEST = 'LOAD_ADMIN_USERS_REQUEST';
export const LOAD_ADMIN_USERS_SUCCESS = 'LOAD_ADMIN_USERS_SUCCESS';
export const LOAD_ADMIN_USERS_FAILURE = 'LOAD_ADMIN_USERS_FAILURE';
export const CREATE_ADMIN_REQUEST = 'CREATE_ADMIN_REQUEST';
export const CREATE_ADMIN_SUCCESS = 'CREATE_ADMIN_SUCCESS';
export const CREATE_ADMIN_FAILURE = 'CREATE_ADMIN_FAILURE';
export const UPDATE_ADMIN_REQUEST = 'UPDATE_ADMIN_REQUEST';
export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_FAILURE = 'UPDATE_ADMIN_FAILURE';

// brand Actions
export const SEARCH_BRAND_REQUEST = 'SEARCH_BRAND_REQUEST';
export const SEARCH_BRAND_SUCCESS = 'SEARCH_BRAND_SUCCESS';
export const SEARCH_BRAND_FAILURE = 'SEARCH_BRAND_FAILURE';
export const CREATE_BRAND_REQUEST = 'CREATE_BRAND_REQUEST';
export const CREATE_BRAND_SUCCESS = 'CREATE_BRAND_SUCCESS';
export const CREATE_BRAND_FAILURE = 'CREATE_BRAND_FAILURE';
export const UPDATE_BRAND_REQUEST = 'UPDATE_BRAND_REQUEST';
export const UPDATE_BRAND_SUCCESS = 'UPDATE_BRAND_SUCCESS';
export const UPDATE_BRAND_FAILURE = 'UPDATE_BRAND_FAILURE';

// Region Actions
export const SEARCH_REGION_REQUEST = 'SEARCH_REGION_REQUEST';
export const SEARCH_REGION_SUCCESS = 'SEARCH_REGION_SUCCESS';
export const SEARCH_REGION_FAILURE = 'SEARCH_REGION_FAILURE';
export const CREATE_REGION_REQUEST = 'CREATE_REGION_REQUEST';
export const CREATE_REGION_SUCCESS = 'CREATE_REGION_SUCCESS';
export const CREATE_REGION_FAILURE = 'CREATE_REGION_FAILURE';
export const UPDATE_REGION_REQUEST = 'UPDATE_REGION_REQUEST';
export const UPDATE_REGION_SUCCESS = 'UPDATE_REGION_SUCCESS';
export const UPDATE_REGION_FAILURE = 'UPDATE_REGION_FAILURE';

// phase Actions
export const SEARCH_PHASE_REQUEST = 'SEARCH_PHASE_REQUEST';
export const SEARCH_PHASE_SUCCESS = 'SEARCH_PHASE_SUCCESS';
export const SEARCH_PHASE_FAILURE = 'SEARCH_PHASE_FAILURE';
export const CREATE_PHASE_REQUEST = 'CREATE_PHASE_REQUEST';
export const CREATE_PHASE_SUCCESS = 'CREATE_PHASE_SUCCESS';
export const CREATE_PHASE_FAILURE = 'CREATE_PHASE_FAILURE';
export const UPDATE_PHASE_REQUEST = 'UPDATE_PHASE_REQUEST';
export const UPDATE_PHASE_SUCCESS = 'UPDATE_PHASE_SUCCESS';
export const UPDATE_PHASE_FAILURE = 'UPDATE_PHASE_FAILURE';

// User Actions
export const SEARCH_USER_REQUEST = 'SEARCH_USER_REQUEST';
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS';
export const SEARCH_USER_FAILURE = 'SEARCH_USER_FAILURE';
export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILURE = 'INVITE_USER_FAILURE';
export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const UPDATE_USER_LOCATIONS_REQUEST = 'UPDATE_USER_LOCATIONS_REQUEST';
export const UPDATE_USER_LOCATIONS_SUCCESS = 'UPDATE_USER_LOCATIONS_SUCCESS';
export const UPDATE_USER_LOCATIONS_FAILURE = 'UPDATE_USER_LOCATIONS_FAILURE';
export const LOAD_INVITE_USER_FILTERS_REQUEST = 'LOAD_INVITE_USER_FILTERS_REQUEST';
export const LOAD_INVITE_USER_FILTERS_SUCCESS = 'LOAD_INVITE_USER_FILTERS_SUCCESS';
export const LOAD_INVITE_USER_FILTERS_FAILURE = 'LOAD_INVITE_USER_FILTERS_FAILURE';
export const LOAD_USER_BULK_LOCATION_FILTERS_REQUEST = 'LOAD_USER_BULK_LOCATION_FILTERS_REQUEST';
export const LOAD_USER_BULK_LOCATION_FILTERS_SUCCESS = 'LOAD_USER_BULK_LOCATION_FILTERS_SUCCESS';
export const LOAD_USER_BULK_LOCATION_FILTERS_FAILURE = 'LOAD_USER_BULK_LOCATION_FILTERS_FAILURE';
export const SEARCH_USER_LOCATION_FILTERS_REQUEST = 'SEARCH_USER_LOCATION_FILTERS_REQUEST';
export const SEARCH_USER_LOCATION_FILTERS_SUCCESS = 'SEARCH_USER_LOCATION_FILTERS_SUCCESS';
export const SEARCH_USER_LOCATION_FILTERS_FAILURE = 'SEARCH_USER_LOCATION_FILTERS_FAILURE';
export const LOAD_LOCATIONS_FILTERS_REQUEST = 'LOAD_LOCATIONS_FILTERS_REQUEST';
export const LOAD_LOCATIONS_FILTERS_SUCCESS = 'LOAD_LOCATIONS_FILTERS_SUCCESS';
export const LOAD_LOCATIONS_FILTERS_FAILURE = 'LOAD_LOCATIONS_FILTERS_FAILURE';
export const LOAD_LOCATION_PUSHDOWN_FILTERS_REQUEST = 'LOAD_LOCATION_PUSHDOWN_FILTERS_REQUEST';
export const LOAD_LOCATION_PUSHDOWN_FILTERS_SUCCESS = 'LOAD_LOCATION_PUSHDOWN_FILTERS_SUCCESS';
export const LOAD_LOCATION_PUSHDOWN_FILTERS_FAILURE = 'LOAD_LOCATION_PUSHDOWN_FILTERS_FAILURE';
export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE';
export const SET_DEFAULT_LOCATION_REQUEST = 'SET_DEFAULT_LOCATION_REQUEST';
export const SET_DEFAULT_LOCATION_SUCCESS = 'SET_DEFAULT_LOCATION_SUCCESS';
export const SET_DEFAULT_LOCATION_FAILURE = 'SET_DEFAULT_LOCATION_FAILURE';
export const ACKNOWLEDGE_WELCOME_MESSAGE_REQUEST = 'ACKNOWLEDGE_WELCOME_MESSAGE_REQUEST';
export const ACKNOWLEDGE_WELCOME_MESSAGE_SUCCESS = 'ACKNOWLEDGE_WELCOME_MESSAGE_SUCCESS';
export const ACKNOWLEDGE_WELCOME_MESSAGE_FAILURE = 'ACKNOWLEDGE_WELCOME_MESSAGE_FAILURE';
export const LOAD_MY_PROFILE_REQUEST = 'LOAD_MY_PROFILE_REQUEST';
export const LOAD_MY_PROFILE_SUCCESS = 'LOAD_MY_PROFILE_SUCCESS';
export const LOAD_MY_PROFILE_FAILURE = 'LOAD_MY_PROFILE_FAILURE';
export const LOAD_MY_PROFILE_FILTERS_REQUEST = 'LOAD_MY_PROFILE_FILTERS_REQUEST';
export const LOAD_MY_PROFILE_FILTERS_SUCCESS = 'LOAD_MY_PROFILE_FILTERS_SUCCESS';
export const LOAD_MY_PROFILE_FILTERS_FAILURE = 'LOAD_MY_PROFILE_FILTERS_FAILURE';
export const SAVE_ACCOUNT_DETAILS_REQUEST = 'SAVE_ACCOUNT_DETAILS_REQUEST';
export const SAVE_ACCOUNT_DETAILS_SUCCESS = 'SAVE_ACCOUNT_DETAILS_SUCCESS';
export const SAVE_ACCOUNT_DETAILS_FAILURE = 'SAVE_ACCOUNT_DETAILS_FAILURE';
export const SAVE_MY_PROFILE_CONFIGURATION_REQUEST = 'SAVE_MY_PROFILE_CONFIGURATION_REQUEST';
export const SAVE_MY_PROFILE_CONFIGURATION_SUCCESS = 'SAVE_MY_PROFILE_CONFIGURATION_SUCCESS';
export const SAVE_MY_PROFILE_CONFIGURATION_FAILURE = 'SAVE_MY_PROFILE_CONFIGURATION_FAILURE';
export const LOAD_USER_SUPPORT_FILTERS_REQUEST = 'LOAD_USER_SUPPORT_FILTERS_REQUEST';
export const LOAD_USER_SUPPORT_FILTERS_SUCCESS = 'LOAD_USER_SUPPORT_FILTERS_SUCCESS';
export const LOAD_USER_SUPPORT_FILTERS_FAILURE = 'LOAD_USER_SUPPORT_FILTERS_FAILURE';
export const LOAD_NOTIFICATION_FILTERS_REQUEST = 'LOAD_NOTIFICATION_FILTERS_REQUEST';
export const LOAD_NOTIFICATION_FILTERS_SUCCESS = 'LOAD_NOTIFICATION_FILTERS_SUCCESS';
export const LOAD_NOTIFICATION_FILTERS_FAILURE = 'LOAD_NOTIFICATION_FILTERS_FAILURE';
export const LOAD_NOTIFICATION_SETTINGS_REQUEST = 'LOAD_NOTIFICATION_SETTINGS_REQUEST';
export const LOAD_NOTIFICATION_SETTINGS_SUCCESS = 'LOAD_NOTIFICATION_SETTINGS_SUCCESS';
export const LOAD_NOTIFICATION_SETTINGS_FAILURE = 'LOAD_NOTIFICATION_SETTINGS_FAILURE';
export const SAVE_NOTIFICATION_SETTINGS_REQUEST = 'SAVE_NOTIFICATION_SETTINGS_REQUEST';
export const SAVE_NOTIFICATION_SETTINGS_SUCCESS = 'SAVE_NOTIFICATION_SETTINGS_SUCCESS';
export const SAVE_NOTIFICATION_SETTINGS_FAILURE = 'SAVE_NOTIFICATION_SETTINGS_FAILURE';
export const GRANT_USER_ALL_BASELINES_REQUEST = 'GRANT_USER_ALL_BASELINES_REQUEST';
export const GRANT_USER_ALL_BASELINES_SUCCESS = 'GRANT_USER_ALL_BASELINES_SUCCESS';
export const GRANT_USER_ALL_BASELINES_FAILURE = 'GRANT_USER_ALL_BASELINES_FAILURE';
export const SAVE_FOLLOWED_DEPARTMENTS_REQUEST = 'SAVE_FOLLOWED_DEPARTMENTS_REQUEST';
export const SAVE_FOLLOWED_DEPARTMENTS_SUCCESS = 'SAVE_FOLLOWED_DEPARTMENTS_SUCCESS';
export const SAVE_FOLLOWED_DEPARTMENTS_FAILURE = 'SAVE_FOLLOWED_DEPARTMENTS_FAILURE';
export const UPDATE_USER_ISACTIVE_REQUEST = 'UPDATE_USER_ISACTIVE_REQUEST';
export const UPDATE_USER_ISACTIVE_SUCCESS = 'UPDATE_USER_ISACTIVE_SUCCESS';
export const UPDATE_USER_ISACTIVE_FAILURE = 'UPDATE_USER_ISACTIVE_FAILURE';
export const GET_MISSING_PROFILE_INPUT_FILTERS_REQUEST = 'GET_MISSING_PROFILE_INPUT_FILTERS_REQUEST';
export const GET_MISSING_PROFILE_INPUT_FILTERS_SUCCESS = 'GET_MISSING_PROFILE_INPUT_FILTERS_SUCCESS';
export const GET_MISSING_PROFILE_INPUT_FILTERS_FAILURE = 'GET_MISSING_PROFILE_INPUT_FILTERS_FAILURE';
export const SAVE_MISSING_PROFILE_INPUT_REQUEST = 'SAVE_MISSING_PROFILE_INPUT_REQUEST';
export const SAVE_MISSING_PROFILE_INPUT_SUCCESS = 'SAVE_MISSING_PROFILE_INPUT_SUCCESS';
export const SAVE_MISSING_PROFILE_INPUT_FAILURE = 'SAVE_MISSING_PROFILE_INPUT_FAILURE';
export const IMPORT_USERS_REQUEST = 'IMPORT_USERS_REQUEST';
export const IMPORT_USERS_SUCCESS = 'IMPORT_USERS_SUCCESS';
export const IMPORT_USERS_FAILURE = 'IMPORT_USERS_FAILURE';
export const GET_SUPPORT_TICKETS_REQUEST = 'GET_SUPPORT_TICKETS_REQUEST';
export const GET_SUPPORT_TICKETS_SUCCESS = 'GET_SUPPORT_TICKETS_SUCCESS';
export const GET_SUPPORT_TICKETS_FAILURE = 'GET_SUPPORT_TICKETS_FAILURE';

// project manager actions
export const SEARCH_PROJECTMANAGER_REQUEST = 'SEARCH_PROJECTMANAGER_REQUEST';
export const SEARCH_PROJECTMANAGER_SUCCESS = 'SEARCH_PROJECTMANAGER_SUCCESS';
export const SEARCH_PROJECTMANAGER_FAILURE = 'SEARCH_PROJECTMANAGER_FAILURE';
export const CREATE_PROJECTMANAGER_REQUEST = 'CREATE_PROJECTMANAGER_REQUEST';
export const CREATE_PROJECTMANAGER_SUCCESS = 'CREATE_PROJECTMANAGER_SUCCESS';
export const CREATE_PROJECTMANAGER_FAILURE = 'CREATE_PROJECTMANAGER_FAILURE';
export const UPDATE_PROJECTMANAGER_REQUEST = 'UPDATE_PROJECTMANAGER_REQUEST';
export const UPDATE_PROJECTMANAGER_SUCCESS = 'UPDATE_PROJECTMANAGER_SUCCESS';
export const UPDATE_PROJECTMANAGER_FAILURE = 'UPDATE_PROJECTMANAGER_FAILURE';

// Continent Actions
export const SEARCH_CONTINENT_REQUEST = 'SEARCH_CONTINENT_REQUEST';
export const SEARCH_CONTINENT_SUCCESS = 'SEARCH_CONTINENT_SUCCESS';
export const SEARCH_CONTINENT_FAILURE = 'SEARCH_CONTINENT_FAILURE';
export const CREATE_CONTINENT_REQUEST = 'CREATE_CONTINENT_REQUEST';
export const CREATE_CONTINENT_SUCCESS = 'CREATE_CONTINENT_SUCCESS';
export const CREATE_CONTINENT_FAILURE = 'CREATE_CONTINENT_FAILURE';
export const UPDATE_CONTINENT_REQUEST = 'UPDATE_CONTINENT_REQUEST';
export const UPDATE_CONTINENT_SUCCESS = 'UPDATE_CONTINENT_SUCCESS';
export const UPDATE_CONTINENT_FAILURE = 'UPDATE_CONTINENT_FAILURE';

// Location Actions
export const SEARCH_LOCATION_REQUEST = 'SEARCH_LOCATION_REQUEST';
export const SEARCH_LOCATION_SUCCESS = 'SEARCH_LOCATION_SUCCESS';
export const SEARCH_LOCATION_FAILURE = 'SEARCH_LOCATION_FAILURE';
export const LOAD_LOCATION_REQUEST = 'LOAD_LOCATION_REQUEST';
export const LOAD_LOCATION_SUCCESS = 'LOAD_LOCATION_SUCCESS';
export const LOAD_LOCATION_FAILURE = 'LOAD_LOCATION_FAILURE';
export const LOAD_LOCATION_USER_ACCESS_REQUEST = 'LOAD_LOCATION_USER_ACCESS_REQUEST';
export const LOAD_LOCATION_USER_ACCESS_SUCCESS = 'LOAD_LOCATION_USER_ACCESS_SUCCESS';
export const LOAD_LOCATION_USER_ACCESS_FAILURE = 'LOAD_LOCATION_USER_ACCESS_FAILURE';
export const SAVE_LOCATION_USER_ACCESS_REQUEST = 'SAVE_LOCATION_USER_ACCESS_REQUEST';
export const SAVE_LOCATION_USER_ACCESS_SUCCESS = 'SAVE_LOCATION_USER_ACCESS_SUCCESS';
export const SAVE_LOCATION_USER_ACCESS_FAILURE = 'SAVE_LOCATION_USER_ACCESS_FAILURE';
export const LOAD_LOCATION_LIST_FILTERS_REQUEST = 'LOAD_LOCATION_LIST_FILTERS_REQUEST';
export const LOAD_LOCATION_LIST_FILTERS_SUCCESS = 'LOAD_LOCATION_LIST_FILTERS_SUCCESS';
export const LOAD_LOCATION_LIST_FILTERS_FAILURE = 'LOAD_LOCATION_LIST_FILTERS_FAILURE';
export const LOAD_LOCATION_FORM_FILTERS_REQUEST = 'LOAD_LOCATION_FORM_FILTERS_REQUEST';
export const LOAD_LOCATION_FORM_FILTERS_SUCCESS = 'LOAD_LOCATION_FORM_FILTERS_SUCCESS';
export const LOAD_LOCATION_FORM_FILTERS_FAILURE = 'LOAD_LOCATION_FORM_FILTERS_FAILURE';
export const CREATE_LOCATION_REQUEST = 'CREATE_LOCATION_REQUEST';
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS';
export const CREATE_LOCATION_FAILURE = 'CREATE_LOCATION_FAILURE';
export const UPDATE_LOCATION_REQUEST = 'UPDATE_LOCATION_REQUEST';
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAILURE = 'UPDATE_LOCATION_FAILURE';
export const PUSHDOWN_LOCATION_REQUEST = 'PUSHDOWN_LOCATION_REQUEST';
export const PUSHDOWN_LOCATION_SUCCESS = 'PUSHDOWN_LOCATION_SUCCESS';
export const PUSHDOWN_LOCATION_FAILURE = 'PUSHDOWN_LOCATION_FAILURE';
export const SEARCH_LOCATION_NAME_REQUEST = 'SEARCH_LOCATION_NAME_REQUEST';
export const SEARCH_LOCATION_NAME_SUCCESS = 'SEARCH_LOCATION_NAME_SUCCESS';
export const SEARCH_LOCATION_NAME_FAILURE = 'SEARCH_LOCATION_NAME_FAILURE';
export const LOAD_LOCATION_DASHBOARD_FILTERS_REQUEST = 'LOAD_LOCATION_DASHBOARD_FILTERS_REQUEST';
export const LOAD_LOCATION_DASHBOARD_FILTERS_SUCCESS = 'LOAD_LOCATION_DASHBOARD_FILTERS_SUCCESS';
export const LOAD_LOCATION_DASHBOARD_FILTERS_FAILURE = 'LOAD_LOCATION_DASHBOARD_FILTERS_FAILURE';
export const LOAD_LOCATION_DASHBOARD_DETAILS_REQUEST = 'LOAD_LOCATION_DASHBOARD_DETAILS_REQUEST';
export const LOAD_LOCATION_DASHBOARD_DETAILS_SUCCESS = 'LOAD_LOCATION_DASHBOARD_DETAILS_SUCCESS';
export const LOAD_LOCATION_DASHBOARD_DETAILS_FAILURE = 'LOAD_LOCATION_DASHBOARD_DETAILS_FAILURE';
export const LOCATION_DASHBOARD_UPDATE_DETAILS_REQUEST = 'LOCATION_DASHBOARD_UPDATE_DETAILS_REQUEST';
export const LOCATION_DASHBOARD_UPDATE_DETAILS_SUCCESS = 'LOCATION_DASHBOARD_UPDATE_DETAILS_SUCCESS';
export const LOCATION_DASHBOARD_UPDATE_DETAILS_FAILURE = 'LOCATION_DASHBOARD_UPDATE_DETAILS_FAILURE';
export const DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_REQUEST = 'DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_REQUEST';
export const DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_SUCCESS = 'DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_SUCCESS';
export const DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_FAILURE = 'DASHBOARD_UNASSIGNED_TASKS_FOR_COACHES_FAILURE';

export const BULK_INACTIVE_LOCATIONS_REQUEST = 'BULK_INACTIVE_LOCATIONS_REQUEST';
export const BULK_INACTIVE_LOCATIONS_SUCCESS = 'BULK_INACTIVE_LOCATIONS_SUCCESS';
export const BULK_INACTIVE_LOCATIONS_FAILURE = 'BULK_INACTIVE_LOCATIONS_FAILURE';
export const BULK_LOCATION_ATTRIBUTES_REQUEST = 'BULK_LOCATION_ATTRIBUTES_REQUEST';
export const BULK_LOCATION_ATTRIBUTES_SUCCESS = 'BULK_LOCATION_ATTRIBUTES_SUCCESS';
export const BULK_LOCATION_ATTRIBUTES_FAILURE = 'BULK_LOCATION_ATTRIBUTES_FAILURE';

export const IMPORT_LOCATION_REQUEST = 'IMPORT_LOCATION_REQUEST';
export const IMPORT_LOCATION_SUCCESS = 'IMPORT_LOCATION_SUCCESS';
export const IMPORT_LOCATION_FAILURE = 'IMPORT_LOCATION_FAILURE';

// Baseline Actions
export const SEARCH_BASELINE_REQUEST = 'SEARCH_BASELINE_REQUEST';
export const SEARCH_BASELINE_SUCCESS = 'SEARCH_BASELINE_SUCCESS';
export const SEARCH_BASELINE_FAILURE = 'SEARCH_BASELINE_FAILURE';
export const GET_BASELINE_REQUEST = 'GET_BASELINE_REQUEST';
export const GET_BASELINE_SUCCESS = 'GET_BASELINE_SUCCESS';
export const GET_BASELINE_FAILURE = 'GET_BASELINE_FAILURE';
export const CREATE_BASELINE_REQUEST = 'CREATE_BASELINE_REQUEST';
export const CREATE_BASELINE_SUCCESS = 'CREATE_BASELINE_SUCCESS';
export const CREATE_BASELINE_FAILURE = 'CREATE_BASELINE_FAILURE';
export const UPDATE_BASELINE_REQUEST = 'UPDATE_BASELINE_REQUEST';
export const UPDATE_BASELINE_SUCCESS = 'UPDATE_BASELINE_SUCCESS';
export const UPDATE_BASELINE_FAILURE = 'UPDATE_BASELINE_FAILURE';
export const LOAD_BASELINE_FILTERS_REQUEST = 'LOAD_BASELINE_FILTERS_REQUEST';
export const LOAD_BASELINE_FILTERS_SUCCESS = 'LOAD_BASELINE_FILTERS_SUCCESS';
export const LOAD_BASELINE_FILTERS_FAILURE = 'LOAD_BASELINE_FILTERS_FAILURE';
export const LOAD_BASELINE_LIST_REQUEST = 'LOAD_BASELINE_LIST_REQUEST';
export const LOAD_BASELINE_LIST_SUCCESS = 'LOAD_BASELINE_LIST_SUCCESS';
export const LOAD_BASELINE_LIST_FAILURE = 'LOAD_BASELINE_LIST_FAILURE';
export const LOAD_PUSHDOWN_LOCATIONS_REQUEST = 'LOAD_PUSHDOWN_LOCATIONS_REQUEST';
export const LOAD_PUSHDOWN_LOCATIONS_SUCCESS = 'LOAD_PUSHDOWN_LOCATIONS_SUCCESS';
export const LOAD_PUSHDOWN_LOCATIONS_FAILURE = 'LOAD_PUSHDOWN_LOCATIONS_FAILURE';
export const PUSHDOWN_BASELINE_REQUEST = 'PUSHDOWN_BASELINE_REQUEST';
export const PUSHDOWN_BASELINE_SUCCESS = 'PUSHDOWN_BASELINE_SUCCESS';
export const PUSHDOWN_BASELINE_FAILURE = 'PUSHDOWN_BASELINE_FAILURE';
export const PREVIEW_BASELINE_PUSHDOWN_REQUEST = 'PREVIEW_BASELINE_PUSHDOWN_REQUEST';
export const PREVIEW_BASELINE_PUSHDOWN_SUCCESS = 'PREVIEW_BASELINE_PUSHDOWN_SUCCESS';
export const PREVIEW_BASELINE_PUSHDOWN_FAILURE = 'PREVIEW_BASELINE_PUSHDOWN_FAILURE';
export const IMPORT_BASELINE_REQUEST = 'IMPORT_BASELINE_REQUEST';
export const IMPORT_BASELINE_SUCCESS = 'IMPORT_BASELINE_SUCCESS';
export const IMPORT_BASELINE_FAILURE = 'IMPORT_BASELINE_FAILURE';
export const COPY_BASELINE_REQUEST = 'COPY_BASELINE_REQUEST';
export const COPY_BASELINE_SUCCESS = 'COPY_BASELINE_SUCCESS';
export const COPY_BASELINE_FAILURE = 'COPY_BASELINE_FAILURE';

// Baseline Task Actions
export const SEARCH_BASELINE_TASK_REQUEST = 'SEARCH_BASELINE_TASK_REQUEST';
export const SEARCH_BASELINE_TASK_SUCCESS = 'SEARCH_BASELINE_TASK_SUCCESS';
export const SEARCH_BASELINE_TASK_FAILURE = 'SEARCH_BASELINE_TASK_FAILURE';
export const LOAD_BASELINE_TASK_LIST_FILTERS_REQUEST = 'LOAD_BASELINE_TASK_LIST_FILTERS_REQUEST';
export const LOAD_BASELINE_TASK_LIST_FILTERS_SUCCESS = 'LOAD_BASELINE_TASK_LIST_FILTERS_SUCCESS';
export const LOAD_BASELINE_TASK_LIST_FILTERS_FAILURE = 'LOAD_BASELINE_TASK_LIST_FILTERS_FAILURE';
export const LOAD_BASELINE_TASK_REQUEST = 'LOAD_BASELINE_TASK_REQUEST';
export const LOAD_BASELINE_TASK_SUCCESS = 'LOAD_BASELINE_TASK_SUCCESS';
export const LOAD_BASELINE_TASK_FAILURE = 'LOAD_BASELINE_TASK_FAILURE';
export const OPTION_SEARCH_BASELINE_TASK_REQUEST = 'OPTION_SEARCH_BASELINE_TASK_REQUEST';
export const OPTION_SEARCH_BASELINE_TASK_SUCCESS = 'OPTION_SEARCH_BASELINE_TASK_SUCCESS';
export const OPTION_SEARCH_BASELINE_TASK_FAILURE = 'OPTION_SEARCH_BASELINE_TASK_FAILURE';
export const CREATE_BASELINE_TASK_REQUEST = 'CREATE_BASELINE_TASK_REQUEST';
export const CREATE_BASELINE_TASK_SUCCESS = 'CREATE_BASELINE_TASK_SUCCESS';
export const CREATE_BASELINE_TASK_FAILURE = 'CREATE_BASELINE_TASK_FAILURE';
export const UPDATE_BASELINE_TASK_REQUEST = 'UPDATE_BASELINE_TASK_REQUEST';
export const UPDATE_BASELINE_TASK_SUCCESS = 'UPDATE_BASELINE_TASK_SUCCESS';
export const UPDATE_BASELINE_TASK_FAILURE = 'UPDATE_BASELINE_TASK_FAILURE';
export const LOAD_BASELINE_TASK_FORM_FILTERS_REQUEST = 'LOAD_BASELINE_TASK_FORM_FILTERS_REQUEST';
export const LOAD_BASELINE_TASK_FORM_FILTERS_SUCCESS = 'LOAD_BASELINE_TASK_FORM_FILTERS_SUCCESS';
export const LOAD_BASELINE_TASK_FORM_FILTERS_FAILURE = 'LOAD_BASELINE_TASK_FORM_FILTERS_FAILURE';
export const LOAD_BULK_PUSHDOWN_FILTERS_REQUEST = 'LOAD_BULK_PUSHDOWN_FILTERS_REQUEST';
export const LOAD_BULK_PUSHDOWN_FILTERS_SUCCESS = 'LOAD_BULK_PUSHDOWN_FILTERS_SUCCESS';
export const LOAD_BULK_PUSHDOWN_FILTERS_FAILURE = 'LOAD_BULK_PUSHDOWN_FILTERS_FAILURE';
export const PERFORM_BULK_PUSHDOWN_REQUEST = 'PERFORM_BULK_PUSHDOWN_REQUEST';
export const PERFORM_BULK_PUSHDOWN_SUCCESS = 'PERFORM_BULK_PUSHDOWN_SUCCESS';
export const PERFORM_BULK_PUSHDOWN_FAILURE = 'PERFORM_BULK_PUSHDOWN_FAILURE';
export const TOGGLE_ACTIVE_TASK_REQUEST = 'TOGGLE_ACTIVE_TASK_REQUEST';
export const TOGGLE_ACTIVE_TASK_SUCCESS = 'TOGGLE_ACTIVE_TASK_SUCCESS';
export const TOGGLE_ACTIVE_TASK_FAILURE = 'TOGGLE_ACTIVE_TASK_FAILURE';
export const LOAD_BULK_LOCATION_ATTRIB_FILTERS_REQUEST = 'LOAD_BULK_LOCATION_ATTRIB_FILTERS_REQUEST';
export const LOAD_BULK_LOCATION_ATTRIB_FILTERS_SUCCESS = 'LOAD_BULK_LOCATION_ATTRIB_FILTERS_SUCCESS';
export const LOAD_BULK_LOCATION_ATTRIB_FILTERS_FAILURE = 'LOAD_BULK_LOCATION_ATTRIB_FILTERS_FAILURE';
export const SEARCH_BULK_LOCATION_PUSHDOWN_REQUEST = 'SEARCH_BULK_LOCATION_PUSHDOWN_REQUEST';
export const SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS = 'SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS';
export const SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE = 'SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE';

export const SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_REQUEST = 'SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_REQUEST';
export const SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS = 'SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS';
export const SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE = 'SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE';

export const SEARCH_BULK_LOCATION_PUSHDOWN_NAME_REQUEST = 'SEARCH_BULK_LOCATION_PUSHDOWN_NAME_REQUEST';
export const SEARCH_BULK_LOCATION_PUSHDOWN_NAME_SUCCESS = 'SEARCH_BULK_LOCATION_PUSHDOWN_NAME_SUCCESS';
export const SEARCH_BULK_LOCATION_PUSHDOWN_NAME_FAILURE = 'SEARCH_BULK_LOCATION_PUSHDOWN_NAME_FAILURE';
export const SEARCH_CROSS_BASELINE_REQUEST = 'SEARCH_CROSS_BASELINE_REQUEST';
export const SEARCH_CROSS_BASELINE_SUCCESS = 'SEARCH_CROSS_BASELINE_SUCCESS';
export const SEARCH_CROSS_BASELINE_FAILURE = 'SEARCH_CROSS_BASELINE_FAILURE';

export const SEARCH_CROSS_BASELINE_LINK_REQUEST = 'SEARCH_CROSS_BASELINE_LINK_REQUEST';
export const SEARCH_CROSS_BASELINE_LINK_SUCCESS = 'SEARCH_CROSS_BASELINE_LINK_SUCCESS';
export const SEARCH_CROSS_BASELINE_LINK_FAILURE = 'SEARCH_CROSS_BASELINE_LINK_FAILURE';

export const SEARCH_CROSS_BASELINE_LINK_COUNT_REQUEST = 'SEARCH_CROSS_BASELINE_LINK_REQUEST';
export const SEARCH_CROSS_BASELINE_LINK_COUNT_SUCCESS = 'SEARCH_CROSS_BASELINE_LINK_SUCCESS';
export const SEARCH_CROSS_BASELINE_LINK_COUNT_FAILURE = 'SEARCH_CROSS_BASELINE_LINK_FAILURE';

export const UPDATE_CROSS_BASELINE_LINK_REQUEST = 'UPDATE_CROSS_BASELINE_LINK_REQUEST';
export const UPDATE_CROSS_BASELINE_LINK_SUCCESS = 'UPDATE_CROSS_BASELINE_LINK_SUCCESS';
export const UPDATE_CROSS_BASELINE_LINK_FAILURE = 'UPDATE_CROSS_BASELINE_LINK_FAILURE';

export const LOAD_CROSS_BASELINE_FORM_FILTERS_REQUEST = 'LOAD_CROSS_BASELINE_FORM_FILTERS_REQUEST';
export const LOAD_CROSS_BASELINE_FORM_FILTERS_SUCCESS = 'LOAD_CROSS_BASELINE_FORM_FILTERS_SUCCESS';
export const LOAD_CROSS_BASELINE_FORM_FILTERS_FAILURE = 'LOAD_CROSS_BASELINE_FORM_FILTERS_FAILURE';
export const LOAD_ORDER_BASELINE_TASKS_FILTERS_REQUEST = 'LOAD_ORDER_BASELINE_TASKS_FILTERS_REQUEST';
export const LOAD_ORDER_BASELINE_TASKS_FILTERS_SUCCESS = 'LOAD_ORDER_BASELINE_TASKS_FILTERS_SUCCESS';
export const LOAD_ORDER_BASELINE_TASKS_FILTERS_FAILURE = 'LOAD_ORDER_BASELINE_TASKS_FILTERS_FAILURE';
export const ORDER_BASELINE_TASKS_REQUEST = 'ORDER_BASELINE_TASKS_REQUEST';
export const ORDER_BASELINE_TASKS_SUCCESS = 'ORDER_BASELINE_TASKS_SUCCESS';
export const ORDER_BASELINE_TASKS_FAILURE = 'ORDER_BASELINE_TASKS_FAILURE';
export const UPDATE_BASELINE_TASKS_DATES_REQUEST = 'UPDATE_BASELINE_TASKS_DATES_REQUEST';
export const UPDATE_BASELINE_TASKS_DATES_SUCCESS = 'UPDATE_BASELINE_TASKS_DATES_SUCCESS';
export const UPDATE_BASELINE_TASKS_DATES_FAILURE = 'UPDATE_BASELINE_TASKS_DATES_FAILURE';
export const SEARCH_BASELINE_TASK_GANTT_REQUEST = 'SEARCH_BASELINE_TASK_GANTT_REQUEST';
export const SEARCH_BASELINE_TASK_GANTT_SUCCESS = 'SEARCH_BASELINE_TASK_GANTT_SUCCESS';
export const SEARCH_BASELINE_TASK_GANTT_FAILURE = 'SEARCH_BASELINE_TASK_GANTT_FAILURE';
export const UPDATE_BASELINE_TASK_CONTINGENT_REQUEST = 'UPDATE_BASELINE_TASK_CONTINGENT_REQUEST';
export const UPDATE_BASELINE_TASK_CONTINGENT_SUCCESS = 'UPDATE_BASELINE_TASK_CONTINGENT_SUCCESS';
export const UPDATE_BASELINE_TASK_CONTINGENT_FAILURE = 'UPDATE_BASELINE_TASK_CONTINGENT_FAILURE';
export const PERFORM_BULK_UPDATE_ATTRIB_REQUEST = 'PERFORM_BULK_UPDATE_ATTRIB_REQUEST';
export const PERFORM_BULK_UPDATE_ATTRIB_SUCCESS = 'PERFORM_BULK_UPDATE_ATTRIB_SUCCESS';
export const PERFORM_BULK_UPDATE_ATTRIB_FAILURE = 'PERFORM_BULK_UPDATE_ATTRIB_FAILURE';
export const LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_REQUEST = 'LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_REQUEST';
export const LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_SUCCESS = 'LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_SUCCESS';
export const LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_FAILURE = 'LOAD_BULK_UPDATE_ATTRIBUTES_FILTERS_FAILURE';

// Status actions
export const SEARCH_STATUS_REQUEST = 'SEARCH_STATUS_REQUEST';
export const SEARCH_STATUS_SUCCESS = 'SEARCH_STATUS_SUCCESS';
export const SEARCH_STATUS_FAILURE = 'SEARCH_STATUS_FAILURE';
export const CREATE_STATUS_REQUEST = 'CREATE_STATUS_REQUEST';
export const CREATE_STATUS_SUCCESS = 'CREATE_STATUS_SUCCESS';
export const CREATE_STATUS_FAILURE = 'CREATE_STATUS_FAILURE';
export const UPDATE_STATUS_REQUEST = 'UPDATE_STATUS_REQUEST';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_FAILURE = 'UPDATE_STATUS_FAILURE';

// Core status actions
export const LIST_CORESTATUS_REQUEST = 'LIST_CORESTATUS_REQUEST';
export const LIST_CORESTATUS_SUCCESS = 'LIST_CORESTATUS_SUCCESS';
export const LIST_CORESTATUS_FAILURE = 'LIST_CORESTATUS_FAILURE';

// Project actions
export const SEARCH_PROJECT_REQUEST = 'SEARCH_PROJECT_REQUEST';
export const SEARCH_PROJECT_SUCCESS = 'SEARCH_PROJECT_SUCCESS';
export const SEARCH_PROJECT_FAILURE = 'SEARCH_PROJECT_FAILURE';
export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAILURE = 'CREATE_PROJECT_FAILURE';
export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAILURE = 'UPDATE_PROJECT_FAILURE';
export const LOAD_PROJECT_FILTERS_REQUEST = 'LOAD_PROJECT_FILTERS_REQUEST';
export const LOAD_PROJECT_FILTERS_SUCCESS = 'LOAD_PROJECT_FILTERS_SUCCESS';
export const LOAD_PROJECT_FILTERS_FAILURE = 'LOAD_PROJECT_FILTERS_FAILURE';
export const LIST_PROJECT_BASELINES_REQUEST = 'LIST_PROJECT_BASELINES_REQUEST';
export const LIST_PROJECT_BASELINES_SUCCESS = 'LIST_PROJECT_BASELINES_SUCCESS';
export const LIST_PROJECT_BASELINES_FAILURE = 'LIST_PROJECT_BASELINES_FAILURE';
export const LOAD_PROJECT_LIST_REQUEST = 'LOAD_PROJECT_LIST_REQUEST';
export const LOAD_PROJECT_LIST_SUCCESS = 'LOAD_PROJECT_LIST_SUCCESS';
export const LOAD_PROJECT_LIST_FAILURE = 'LOAD_PROJECT_LIST_FAILURE';
export const COPY_PROJECT_REQUEST = 'COPY_PROJECT_REQUEST';
export const COPY_PROJECT_SUCCESS = 'COPY_PROJECT_SUCCESS';
export const COPY_PROJECT_FAILURE = 'COPY_PROJECT_FAILURE';
export const SET_PROJECTMANAGER_FILTER = 'SET_PROJECTMANAGER_FILTER';
export const UPDATE_PROJECT_NAME_REQUEST = 'UPDATE_PROJECT_NAME_REQUEST';
export const UPDATE_PROJECT_NAME_SUCCESS = 'UPDATE_PROJECT_NAME_SUCCESS';
export const UPDATE_PROJECT_NAME_FAILURE = 'UPDATE_PROJECT_NAME_FAILURE';
export const UPDATE_PROJECT_STATUS_REQUEST = 'UPDATE_PROJECT_STATUS_REQUEST';
export const UPDATE_PROJECT_STATUS_SUCCESS = 'UPDATE_PROJECT_STATUS_SUCCESS';
export const UPDATE_PROJECT_STATUS_FAILURE = 'UPDATE_PROJECT_STATUS_FAILURE';
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';
export const POST_SAVE_FAVORITE_PROJECT_REQUEST = 'POST_SAVE_FAVORITE_PROJECT_REQUEST';
export const POST_SAVE_FAVORITE_PROJECT_SUCCESS = 'POST_SAVE_FAVORITE_PROJECT_SUCCESS';
export const POST_SAVE_FAVORITE_PROJECT_FAILURE = 'POST_SAVE_FAVORITE_PROJECT_FAILURE';

// Project Location actions
export const SEARCH_PROJECTLOCATION_REQUEST = 'SEARCH_PROJECTLOCATION_REQUEST';
export const SEARCH_PROJECTLOCATION_SUCCESS = 'SEARCH_PROJECTLOCATION_SUCCESS';
export const SEARCH_PROJECTLOCATION_FAILURE = 'SEARCH_PROJECTLOCATION_FAILURE';
export const LOAD_PROJECTLOCATION_FILTERS_REQUEST = 'LOAD_PROJECTLOCATION_FILTERS_REQUEST';
export const LOAD_PROJECTLOCATION_FILTERS_SUCCESS = 'LOAD_PROJECTLOCATION_FILTERS_SUCCESS';
export const LOAD_PROJECTLOCATION_FILTERS_FAILURE = 'LOAD_PROJECTLOCATION_FILTERS_FAILURE';
export const ADD_TO_PROJECTLOCATION_SCOPE_REQUEST = 'ADD_TO_PROJECTLOCATION_SCOPE_REQUEST';
export const ADD_TO_PROJECTLOCATION_SCOPE_SUCCESS = 'ADD_TO_PROJECTLOCATION_SCOPE_SUCCESS';
export const ADD_TO_PROJECTLOCATION_SCOPE_FAILURE = 'ADD_TO_PROJECTLOCATION_SCOPE_FAILURE';
export const LOAD_ALL_PROJECTLOCATION_LOCATIONS_REQUEST = 'LOAD_ALL_PROJECTLOCATION_LOCATIONS_REQUEST';
export const LOAD_ALL_PROJECTLOCATION_LOCATIONS_SUCCESS = 'LOAD_ALL_PROJECTLOCATION_LOCATIONS_SUCCESS';
export const LOAD_ALL_PROJECTLOCATION_LOCATIONS_FAILURE = 'LOAD_ALL_PROJECTLOCATION_LOCATIONS_FAILURE';
export const SEARCH_PROJECTLOCATION_NAME_REQUEST = 'SEARCH_PROJECTLOCATION_NAME_REQUEST';
export const SEARCH_PROJECTLOCATION_NAME_SUCCESS = 'SEARCH_PROJECTLOCATION_NAME_SUCCESS';
export const SEARCH_PROJECTLOCATION_NAME_FAILURE = 'SEARCH_PROJECTLOCATION_NAME_FAILURE';
export const LOAD_PROJECTLOCATION_LOCATION_FILTERS_REQUEST = 'LOAD_PROJECTLOCATION_LOCATION_FILTERS_REQUEST';
export const LOAD_PROJECTLOCATION_LOCATION_FILTERS_SUCCESS = 'LOAD_PROJECTLOCATION_LOCATION_FILTERS_SUCCESS';
export const LOAD_PROJECTLOCATION_LOCATION_FILTERS_FAILURE = 'LOAD_PROJECTLOCATION_LOCATION_FILTERS_FAILURE';
export const SEARCH_PROJECTLOCATION_LOCATIONS_REQUEST = 'SEARCH_PROJECTLOCATION_LOCATIONS_REQUEST';
export const SEARCH_PROJECTLOCATION_LOCATIONS_SUCCESS = 'SEARCH_PROJECTLOCATION_LOCATIONS_SUCCESS';
export const SEARCH_PROJECTLOCATION_LOCATIONS_FAILURE = 'SEARCH_PROJECTLOCATION_LOCATIONS_FAILURE';
export const REMOVE_FROM_PROJECTLOCATION_SCOPE_REQUEST = 'REMOVE_FROM_PROJECTLOCATION_SCOPE_REQUEST';
export const REMOVE_FROM_PROJECTLOCATION_SCOPE_SUCCESS = 'REMOVE_FROM_PROJECTLOCATION_SCOPE_SUCCESS';
export const REMOVE_FROM_PROJECTLOCATION_SCOPE_FAILURE = 'REMOVE_FROM_PROJECTLOCATION_SCOPE_FAILURE';
export const UPDATE_PROJECTLOCATION_MANAGER_REQUEST = 'UPDATE_PROJECTLOCATION_MANAGER_REQUEST';
export const UPDATE_PROJECTLOCATION_MANAGER_SUCCESS = 'UPDATE_PROJECTLOCATION_MANAGER_SUCCESS';
export const UPDATE_PROJECTLOCATION_MANAGER_FAILURE = 'UPDATE_PROJECTLOCATION_MANAGER_FAILURE';
export const PUSHDOWN_PROJECTLOCATION_REQUEST = 'PUSHDOWN_PROJECTLOCATION_REQUEST';
export const PUSHDOWN_PROJECTLOCATION_SUCCESS = 'PUSHDOWN_PROJECTLOCATION_SUCCESS';
export const PUSHDOWN_PROJECTLOCATION_FAILURE = 'PUSHDOWN_PROJECTLOCATION_FAILURE';
export const ADD_BASELINE_PROJECTLOCATION_REQUEST = 'ADD_BASELINE_PROJECTLOCATION_REQUEST';
export const ADD_BASELINE_PROJECTLOCATION_SUCCESS = 'ADD_BASELINE_PROJECTLOCATION_SUCCESS';
export const ADD_BASELINE_PROJECTLOCATION_FAILURE = 'ADD_BASELINE_PROJECTLOCATION_FAILURE';
export const UPDATE_PROJECTLOCATION_ONHOLD_REQUEST = 'UPDATE_PROJECTLOCATION_ONHOLD_REQUEST';
export const UPDATE_PROJECTLOCATION_ONHOLD_SUCCESS = 'UPDATE_PROJECTLOCATION_ONHOLD_SUCCESS';
export const UPDATE_PROJECTLOCATION_ONHOLD_FAILURE = 'UPDATE_PROJECTLOCATION_ONHOLD_FAILURE';
export const UPDATE_PROJECTLOCATION_ZERODATE_REQUEST = 'UPDATE_PROJECTLOCATION_ZERODATE_REQUEST';
export const UPDATE_PROJECTLOCATION_ZERODATE_SUCCESS = 'UPDATE_PROJECTLOCATION_ZERODATE_SUCCESS';
export const UPDATE_PROJECTLOCATION_ZERODATE_FAILURE = 'UPDATE_PROJECTLOCATION_ZERODATE_FAILURE';
export const UPDATE_PROJECTLOCATION_EPICDATE_REQUEST = 'UPDATE_PROJECTLOCATION_EPICDATE_REQUEST';
export const UPDATE_PROJECTLOCATION_EPICDATE_SUCCESS = 'UPDATE_PROJECTLOCATION_EPICDATE_SUCCESS';
export const UPDATE_PROJECTLOCATION_EPICDATE_FAILURE = 'UPDATE_PROJECTLOCATION_EPICDATE_FAILURE';
export const REVOKE_PUSHDOWN_PROJECTLOCATION_REQUEST = 'REVOKE_PUSHDOWN_PROJECTLOCATION_REQUEST';
export const REVOKE_PUSHDOWN_PROJECTLOCATION_SUCCESS = 'REVOKE_PUSHDOWN_PROJECTLOCATION_SUCCESS';
export const REVOKE_PUSHDOWN_PROJECTLOCATION_FAILURE = 'REVOKE_PUSHDOWN_PROJECTLOCATION_FAILURE';
export const REVOKE_BASELINE_PROJECTLOCATION_REQUEST = 'REVOKE_BASELINE_PROJECTLOCATION_REQUEST';
export const REVOKE_BASELINE_PROJECTLOCATION_SUCCESS = 'REVOKE_BASELINE_PROJECTLOCATION_SUCCESS';
export const REVOKE_BASELINE_PROJECTLOCATION_FAILURE = 'REVOKE_BASELINE_PROJECTLOCATION_FAILURE';
export const LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_REQUEST = 'LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_REQUEST';
export const LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_SUCCESS = 'LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_SUCCESS';
export const LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_FAILURE = 'LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_FAILURE';
export const UPDATE_PROJECTLOCATION_COACH_REQUEST = 'UPDATE_PROJECTLOCATION_COACH_REQUEST';
export const UPDATE_PROJECTLOCATION_COACH_SUCCESS = 'UPDATE_PROJECTLOCATION_COACH_SUCCESS';
export const UPDATE_PROJECTLOCATION_COACH_FAILURE = 'UPDATE_PROJECTLOCATION_COACH_FAILURE';
export const REQUEST_PROJECTLOCATION_WAIVER_REQUEST = 'REQUEST_PROJECTLOCATION_WAIVER_REQUEST';
export const REQUEST_PROJECTLOCATION_WAIVER_SUCCESS = 'REQUEST_PROJECTLOCATION_WAIVER_SUCCESS';
export const REQUEST_PROJECTLOCATION_WAIVER_FAILURE = 'REQUEST_PROJECTLOCATION_WAIVER_FAILURE';
export const DELETE_PROJECTLOCATION_WAIVER_REQUEST_REQUEST = 'DELETE_PROJECTLOCATION_WAIVER_REQUEST_REQUEST';
export const DELETE_PROJECTLOCATION_WAIVER_REQUEST_SUCCESS = 'DELETE_PROJECTLOCATION_WAIVER_REQUEST_SUCCESS';
export const DELETE_PROJECTLOCATION_WAIVER_REQUEST_FAILURE = 'DELETE_PROJECTLOCATION_WAIVER_REQUEST_FAILURE';
export const SEARCH_PROJECTLOCATION_WAIVER_REQUEST = 'SEARCH_PROJECTLOCATION_WAIVER_REQUEST';
export const SEARCH_PROJECTLOCATION_WAIVER_SUCCESS = 'SEARCH_PROJECTLOCATION_WAIVER_SUCCESS';
export const SEARCH_PROJECTLOCATION_WAIVER_FAILURE = 'SEARCH_PROJECTLOCATION_WAIVER_FAILURE';
export const APPROVE_DENY_PROJECTLOCATION_WAIVER_REQUEST = 'APPROVE_DENY_PROJECTLOCATION_WAIVER_REQUEST';
export const APPROVE_DENY_PROJECTLOCATION_WAIVER_SUCCESS = 'APPROVE_DENY_PROJECTLOCATION_WAIVER_SUCCESS';
export const APPROVE_DENY_PROJECTLOCATION_WAIVER_FAILURE = 'APPROVE_DENY_PROJECTLOCATION_WAIVER_FAILURE';

// Support actions
export const CREATE_SUBSCRIPTION_TICKET_REQUEST = 'CREATE_SUBSCRIPTION_TICKET_REQUEST';
export const CREATE_SUBSCRIPTION_TICKET_SUCCESS = 'CREATE_SUBSCRIPTION_TICKET_SUCCESS';
export const CREATE_SUBSCRIPTION_TICKET_FAILURE = 'CREATE_SUBSCRIPTION_TICKET_FAILURE';
export const CREATE_EHSOLUTION_TICKET_REQUEST = 'CREATE_EHSOLUTION_TICKET_REQUEST';
export const CREATE_EHSOLUTION_TICKET_SUCCESS = 'CREATE_EHSOLUTION_TICKET_SUCCESS';
export const CREATE_EHSOLUTION_TICKET_FAILURE = 'CREATE_EHSOLUTION_TICKET_FAILURE';
export const LOAD_SUPPORT_TICKET_REQUEST = 'LOAD_SUPPORT_TICKET_REQUEST';
export const LOAD_SUPPORT_TICKET_SUCCESS = 'LOAD_SUPPORT_TICKET_SUCCESS';
export const LOAD_SUPPORT_TICKET_FAILURE = 'LOAD_SUPPORT_TICKET_FAILURE';
export const SEARCH_SUPPORT_TICKET_REQUEST = 'SEARCH_SUPPORT_TICKET_REQUEST';
export const SEARCH_SUPPORT_TICKET_SUCCESS = 'SEARCH_SUPPORT_TICKET_SUCCESS';
export const SEARCH_SUPPORT_TICKET_FAILURE = 'SEARCH_SUPPORT_TICKET_FAILURE';
export const LOAD_SUPPORT_TICKET_FILTERS_REQUEST = 'LOAD_SUPPORT_TICKET_FILTERS_REQUEST';
export const LOAD_SUPPORT_TICKET_FILTERS_SUCCESS = 'LOAD_SUPPORT_TICKET_FILTERS_SUCCESS';
export const LOAD_SUPPORT_TICKET_FILTERS_FAILURE = 'LOAD_SUPPORT_TICKET_FILTERS_FAILURE';
export const UPDATE_SUPPORT_TICKET_AGENT_REQUEST = 'UPDATE_SUPPORT_TICKET_AGENT_REQUEST';
export const UPDATE_SUPPORT_TICKET_AGENT_SUCCESS = 'UPDATE_SUPPORT_TICKET_AGENT_SUCCESS';
export const UPDATE_SUPPORT_TICKET_AGENT_FAILURE = 'UPDATE_SUPPORT_TICKET_AGENT_FAILURE';
export const LOAD_TICKET_REQUEST = 'LOAD_TICKET_REQUEST';
export const LOAD_TICKET_SUCCESS = 'LOAD_TICKET_SUCCESS';
export const LOAD_TICKET_FAILURE = 'LOAD_TICKET_FAILURE';
export const LOAD_TICKET_FILTERS_REQUEST = 'LOAD_TICKET_FILTERS_REQUEST';
export const LOAD_TICKET_FILTERS_SUCCESS = 'LOAD_TICKET_FILTERS_SUCCESS';
export const LOAD_TICKET_FILTERS_FAILURE = 'LOAD_TICKET_FILTERS_FAILURE';
export const UPDATE_SUPPORT_TICKET_REQUEST = 'UPDATE_SUPPORT_TICKET_REQUEST';
export const UPDATE_SUPPORT_TICKET_SUCCESS = 'UPDATE_SUPPORT_TICKET_SUCCESS';
export const UPDATE_SUPPORT_TICKET_FAILURE = 'UPDATE_SUPPORT_TICKET_FAILURE';
export const LOAD_TICKET_CONVERSATION_REQUEST = 'LOAD_TICKET_CONVERSATION_REQUEST';
export const LOAD_TICKET_CONVERSATION_SUCCESS = 'LOAD_TICKET_CONVERSATION_SUCCESS';
export const LOAD_TICKET_CONVERSATION_FAILURE = 'LOAD_TICKET_CONVERSATION_FAILURE';
export const REQUESTOR_REPLY_SUPPORT_TICKET_REQUEST = 'REQUESTOR_REPLY_SUPPORT_TICKET_REQUEST';
export const REQUESTOR_REPLY_SUPPORT_TICKET_SUCCESS = 'REQUESTOR_REPLY_SUPPORT_TICKET_SUCCESS';
export const REQUESTOR_REPLY_SUPPORT_TICKET_FAILURE = 'REQUESTOR_REPLY_SUPPORT_TICKET_FAILURE';

export const SUBMIT_FEEDBACK_REQUEST = 'SUBMIT_FEEDBACK_REQUEST';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';

// Window Actions
export const HANDLE_WINDOW_RESIZE = 'HANDLE_WINDOW_RESIZE';

// User Access Request Actions
export const CHECK_ACCESS_CODE_REQUEST = 'CHECK_ACCESS_CODE_REQUEST';
export const CHECK_ACCESS_CODE_SUCCESS = 'CHECK_ACCESS_CODE_SUCCESS';
export const CHECK_ACCESS_CODE_FAILURE = 'CHECK_ACCESS_CODE_FAILURE';

export const CHECK_ADD_SUB_ACCESS_CODE_REQUEST = 'CHECK_ADD_SUB_ACCESS_CODE_REQUEST';
export const CHECK_ADD_SUB_ACCESS_CODE_SUCCESS = 'CHECK_ADD_SUB_ACCESS_CODE_SUCCESS';
export const CHECK_ADD_SUB_ACCESS_CODE_FAILURE = 'CHECK_ADD_SUB_ACCESS_CODE_FAILURE';

export const CHECK_USER_NAME_REQUEST = 'CHECK_USER_NAME_REQUEST';
export const CHECK_USER_NAME_SUCCESS = 'CHECK_USER_NAME_SUCCESS';
export const CHECK_USER_NAME_FAILURE = 'CHECK_USER_NAME_FAILURE';
export const LOAD_USER_REQUEST_PROFILE_FILTERS_REQUEST = 'LOAD_USER_REQUEST_PROFILE_FILTERS_REQUEST';
export const LOAD_USER_REQUEST_PROFILE_FILTERS_SUCCESS = 'LOAD_USER_REQUEST_PROFILE_FILTERS_SUCCESS';
export const LOAD_USER_REQUEST_PROFILE_FILTERS_FAILURE = 'LOAD_USER_REQUEST_PROFILE_FILTERS_FAILURE';
export const CREATE_USER_ACCESS_REQUEST_REQUEST = 'CREATE_USER_ACCESS_REQUEST_REQUEST';
export const CREATE_USER_ACCESS_REQUEST_SUCCESS = 'CREATE_USER_ACCESS_REQUEST_SUCCESS';
export const CREATE_USER_ACCESS_REQUEST_FAILURE = 'CREATE_USER_ACCESS_REQUEST_FAILURE';
export const LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_REQUEST = 'LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_REQUEST';
export const LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_SUCCESS = 'LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_SUCCESS';
export const LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_FAILURE = 'LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_FAILURE';
export const SEARCH_USER_ACCESS_REQUEST_REQUEST = 'SEARCH_USER_ACCESS_REQUEST_REQUEST';
export const SEARCH_USER_ACCESS_REQUEST_SUCCESS = 'SEARCH_USER_ACCESS_REQUEST_SUCCESS';
export const SEARCH_USER_ACCESS_REQUEST_FAILURE = 'SEARCH_USER_ACCESS_REQUEST_FAILURE';
export const UPDATE_USER_ACCESS_REQUEST_REQUEST = 'UPDATE_USER_ACCESS_REQUEST_REQUEST';
export const UPDATE_USER_ACCESS_REQUEST_SUCCESS = 'UPDATE_USER_ACCESS_REQUEST_SUCCESS';
export const UPDATE_USER_ACCESS_REQUEST_FAILURE = 'UPDATE_USER_ACCESS_REQUEST_FAILURE';
export const LOAD_USER_REQUEST_JOB_TITLES_REQUEST = 'LOAD_USER_REQUEST_JOB_TITLES_REQUEST';
export const LOAD_USER_REQUEST_JOB_TITLES_SUCCESS = 'LOAD_USER_REQUEST_JOB_TITLES_SUCCESS';
export const LOAD_USER_REQUEST_JOB_TITLES_FAILURE = 'LOAD_USER_REQUEST_JOB_TITLES_FAILURE';
export const LOAD_USER_REQUEST_UPDATE_FILTERS_REQUEST = 'LOAD_USER_REQUEST_UPDATE_FILTERS_REQUEST';
export const LOAD_USER_REQUEST_UPDATE_FILTERS_SUCCESS = 'LOAD_USER_REQUEST_UPDATE_FILTERS_SUCCESS';
export const LOAD_USER_REQUEST_UPDATE_FILTERS_FAILURE = 'LOAD_USER_REQUEST_UPDATE_FILTERS_FAILURE';
export const LOAD_USER_ACCESS_REQUEST_REQUEST = 'LOAD_USER_ACCESS_REQUEST_REQUEST';
export const LOAD_USER_ACCESS_REQUEST_SUCCESS = 'LOAD_USER_ACCESS_REQUEST_SUCCESS';
export const LOAD_USER_ACCESS_REQUEST_FAILURE = 'LOAD_USER_ACCESS_REQUEST_FAILURE';
export const DENY_USER_ACCESS_REQUEST_REQUEST = 'DENY_USER_ACCESS_REQUEST_REQUEST';
export const DENY_USER_ACCESS_REQUEST_SUCCESS = 'DENY_USER_ACCESS_REQUEST_SUCCESS';
export const DENY_USER_ACCESS_REQUEST_FAILURE = 'DENY_USER_ACCESS_REQUEST_FAILURE';
export const APPROVE_USER_ACCESS_REQUEST_REQUEST = 'APPROVE_USER_ACCESS_REQUEST_REQUEST';
export const APPROVE_USER_ACCESS_REQUEST_SUCCESS = 'APPROVE_USER_ACCESS_REQUEST_SUCCESS';
export const APPROVE_USER_ACCESS_REQUEST_FAILURE = 'APPROVE_USER_ACCESS_REQUEST_FAILURE';

export const CREATE_ADD_SUBSCRIPTION_REQUEST_REQUEST = 'CREATE_ADD_SUBSCRIPTION_REQUEST_REQUEST';
export const CREATE_ADD_SUBSCRIPTION_REQUEST_SUCCESS = 'CREATE_ADD_SUBSCRIPTION_REQUEST_SUCCESS';
export const CREATE_ADD_SUBSCRIPTION_REQUEST_FAILURE = 'CREATE_ADD_SUBSCRIPTION_REQUEST_FAILURE';

// Files Actions
export const LOAD_FILES_FILTERS_REQUEST = 'LOAD_FILES_FILTERS_REQUEST';
export const LOAD_FILES_FILTERS_SUCCESS = 'LOAD_FILES_FILTERS_SUCCESS';
export const LOAD_FILES_FILTERS_FAILURE = 'LOAD_FILES_FILTERS_FAILURE';
export const LOAD_FILE_REQUEST = 'LOAD_FILE_REQUEST';
export const LOAD_FILE_SUCCESS = 'LOAD_FILE_SUCCESS';
export const LOAD_FILE_FAILURE = 'LOAD_FILE_FAILURE';
export const CREATE_FILE_REQUEST = 'CREATE_FILE_REQUEST';
export const CREATE_FILE_SUCCESS = 'CREATE_FILE_SUCCESS';
export const CREATE_FILE_FAILURE = 'CREATE_FILE_FAILURE';
export const UPDATE_FILE_REQUEST = 'UPDATE_FILE_REQUEST';
export const UPDATE_FILE_SUCCESS = 'UPDATE_FILE_SUCCESS';
export const UPDATE_FILE_FAILURE = 'UPDATE_FILE_FAILURE';
export const LOAD_FILES_LIST_FILTERS_REQUEST = 'LOAD_FILES_LIST_FILTERS_REQUEST';
export const LOAD_FILES_LIST_FILTERS_SUCCESS = 'LOAD_FILES_LIST_FILTERS_SUCCESS';
export const LOAD_FILES_LIST_FILTERS_FAILURE = 'LOAD_FILES_LIST_FILTERS_FAILURE';
export const SEARCH_FILES_REQUEST = 'SEARCH_FILES_REQUEST';
export const SEARCH_FILES_SUCCESS = 'SEARCH_FILES_SUCCESS';
export const SEARCH_FILES_FAILURE = 'SEARCH_FILES_FAILURE';
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';
export const CREATE_MULTIPLE_FILES_REQUEST = 'CREATE_MULTIPLE_FILES_REQUEST';
export const CREATE_MULTIPLE_FILES_SUCCESS = 'CREATE_MULTIPLE_FILES_SUCCESS';
export const CREATE_MULTIPLE_FILES_FAILURE = 'CREATE_MULTIPLE_FILES_FAILURE';

// Location Task List Actions
export const SET_LOCATION_FILTER_STATE = 'SET_LOCATION_FILTER_STATE';
export const SET_LOCATION_KEY_STATE = 'SET_LOCATION_KEY_STATE';
export const SET_LOCATION_SELECTOR_FILTERS = 'SET_LOCATION_SELECTOR_FILTERS';
export const SEARCH_LOCATION_TASK_LIST_REQUEST = 'SEARCH_LOCATION_TASK_LIST_REQUEST';
export const SEARCH_LOCATION_TASK_LIST_SUCCESS = 'SEARCH_LOCATION_TASK_LIST_SUCCESS';
export const SEARCH_LOCATION_TASK_LIST_FAILURE = 'SEARCH_LOCATION_TASK_LIST_FAILURE';
export const LOAD_LOCATION_SELECTOR_FILTERS_REQUEST = 'LOAD_LOCATION_SELECTOR_FILTERS_REQUEST';
export const LOAD_LOCATION_SELECTOR_FILTERS_SUCCESS = 'LOAD_LOCATION_SELECTOR_FILTERS_SUCCESS';
export const LOAD_LOCATION_SELECTOR_FILTERS_FAILURE = 'LOAD_LOCATION_SELECTOR_FILTERS_FAILURE';
export const LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_REQUEST = 'LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_REQUEST';
export const LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_SUCCESS = 'LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_SUCCESS';
export const LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_FAILURE = 'LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_FAILURE';
export const LOAD_LOCATION_TASK_LIST_FILTERS_REQUEST = 'LOAD_LOCATION_TASK_LIST_FILTERS_REQUEST';
export const LOAD_LOCATION_TASK_LIST_FILTERS_SUCCESS = 'LOAD_LOCATION_TASK_LIST_FILTERS_SUCCESS';
export const LOAD_LOCATION_TASK_LIST_FILTERS_FAILURE = 'LOAD_LOCATION_TASK_LIST_FILTERS_FAILURE';
export const UPDATE_LOCATION_TASK_LIST_COLUMNS_REQUEST = 'UPDATE_LOCATION_TASK_LIST_COLUMNS_REQUEST';
export const UPDATE_LOCATION_TASK_LIST_COLUMNS_SUCCESS = 'UPDATE_LOCATION_TASK_LIST_COLUMNS_SUCCESS';
export const UPDATE_LOCATION_TASK_LIST_COLUMNS_FAILURE = 'UPDATE_LOCATION_TASK_LIST_COLUMNS_FAILURE';
export const LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_REQUEST = 'LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_REQUEST';
export const LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_SUCCESS = 'LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_SUCCESS';
export const LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_FAILURE = 'LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_FAILURE';
export const UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_REQUEST = 'UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_REQUEST';
export const UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_SUCCESS = 'UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_SUCCESS';
export const UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_FAILURE = 'UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_FAILURE';
export const SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_REQUEST = 'SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_REQUEST';
export const SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_SUCCESS = 'SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_SUCCESS';
export const SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_FAILURE = 'SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_FAILURE';
export const UPDATE_LOCATION_TASK_LIST_STATUS_REQUEST = 'UPDATE_LOCATION_TASK_LIST_STATUS_REQUEST';
export const UPDATE_LOCATION_TASK_LIST_STATUS_SUCCESS = 'UPDATE_LOCATION_TASK_LIST_STATUS_SUCCESS';
export const UPDATE_LOCATION_TASK_LIST_STATUS_FAILURE = 'UPDATE_LOCATION_TASK_LIST_STATUS_FAILURE';
export const LOAD_LOCATION_TASK_REQUEST = 'LOAD_LOCATION_TASK_REQUEST';
export const LOAD_LOCATION_TASK_SUCCESS = 'LOAD_LOCATION_TASK_SUCCESS';
export const LOAD_LOCATION_TASK_FAILURE = 'LOAD_LOCATION_TASK_FAILURE';
export const LOAD_LOCATION_TASK_DRAWER_FILTERS_REQUEST = 'LOAD_LOCATION_TASK_DRAWER_FILTERS_REQUEST';
export const LOAD_LOCATION_TASK_DRAWER_FILTERS_SUCCESS = 'LOAD_LOCATION_TASK_DRAWER_FILTERS_SUCCESS';
export const LOAD_LOCATION_TASK_DRAWER_FILTERS_FAILURE = 'LOAD_LOCATION_TASK_DRAWER_FILTERS_FAILURE';
export const LOAD_LIMITED_MODE_FILTERS_REQUEST = 'LOAD_LIMITED_MODE_FILTERS_REQUEST';
export const LOAD_LIMITED_MODE_FILTERS_SUCCESS = 'LOAD_LIMITED_MODE_FILTERS_SUCCESS';
export const LOAD_LIMITED_MODE_FILTERS_FAILURE = 'LOAD_LIMITED_MODE_FILTERS_FAILURE';
export const UPDATE_LOCATION_TASK_LIMITED_MODE_REQUEST = 'UPDATE_LOCATION_TASK_LIMITED_MODE_REQUEST';
export const UPDATE_LOCATION_TASK_LIMITED_MODE_SUCCESS = 'UPDATE_LOCATION_TASK_LIMITED_MODE_SUCCESS';
export const UPDATE_LOCATION_TASK_LIMITED_MODE_FAILURE = 'UPDATE_LOCATION_TASK_LIMITED_MODE_FAILURE';
export const UPDATE_LOCATION_TASK_EDIT_MODE_REQUEST = 'UPDATE_LOCATION_TASK_EDIT_MODE_REQUEST';
export const UPDATE_LOCATION_TASK_EDIT_MODE_SUCCESS = 'UPDATE_LOCATION_TASK_EDIT_MODE_SUCCESS';
export const UPDATE_LOCATION_TASK_EDIT_MODE_FAILURE = 'UPDATE_LOCATION_TASK_EDIT_MODE_FAILURE';
export const UPDATE_LOCATION_TASK_SUCCESS = 'UPDATE_LOCATION_TASK_SUCCESS';
export const UPDATE_LOCATION_TASK_FAILURE = 'UPDATE_LOCATION_TASK_FAILURE';
export const LOAD_LOCATION_TASK_COMMENTS_REQUEST = 'LOAD_LOCATION_TASK_COMMENTS_REQUEST';
export const LOAD_LOCATION_TASK_COMMENTS_SUCCESS = 'LOAD_LOCATION_TASK_COMMENTS_SUCCESS';
export const LOAD_LOCATION_TASK_COMMENTS_FAILURE = 'LOAD_LOCATION_TASK_COMMENTS_FAILURE';
export const CREATE_LOCATION_TASK_COMMENT_REQUEST = 'CREATE_LOCATION_TASK_COMMENT_REQUEST';
export const CREATE_LOCATION_TASK_COMMENT_SUCCESS = 'CREATE_LOCATION_TASK_COMMENT_SUCCESS';
export const CREATE_LOCATION_TASK_COMMENT_FAILURE = 'CREATE_LOCATION_TASK_COMMENT_FAILURE';
export const UPDATE_LOCATION_TASK_COMMENT_REQUEST = 'UPDATE_LOCATION_TASK_COMMENT_REQUEST';
export const UPDATE_LOCATION_TASK_COMMENT_SUCCESS = 'UPDATE_LOCATION_TASK_COMMENT_SUCCESS';
export const UPDATE_LOCATION_TASK_COMMENT_FAILURE = 'UPDATE_LOCATION_TASK_COMMENT_FAILURE';
export const UPDATE_LOCATION_TASK_LIST_ISACTIVE_REQUEST = 'UPDATE_LOCATION_TASK_LIST_ISACTIVE_REQUEST';
export const UPDATE_LOCATION_TASK_LIST_ISACTIVE_SUCCESS = 'UPDATE_LOCATION_TASK_LIST_ISACTIVE_SUCCESS';
export const UPDATE_LOCATION_TASK_LIST_ISACTIVE_FAILURE = 'UPDATE_LOCATION_TASK_LIST_ISACTIVE_FAILURE';
export const UPDATE_LOCATION_TASK_LIST_FOLLOW_REQUEST = 'UPDATE_LOCATION_TASK_LIST_FOLLOW_REQUEST';
export const UPDATE_LOCATION_TASK_LIST_FOLLOW_SUCCESS = 'UPDATE_LOCATION_TASK_LIST_FOLLOW_SUCCESS';
export const UPDATE_LOCATION_TASK_LIST_FOLLOW_FAILURE = 'UPDATE_LOCATION_TASK_LIST_FOLLOW_FAILURE';
export const LOAD_LOCATION_TASK_HISTORY_REQUEST = 'LOAD_LOCATION_TASK_HISTORY_REQUEST';
export const LOAD_LOCATION_TASK_HISTORY_SUCCESS = 'LOAD_LOCATION_TASK_HISTORY_SUCCESS';
export const LOAD_LOCATION_TASK_HISTORY_FAILURE = 'LOAD_LOCATION_TASK_HISTORY_FAILURE';
export const CREATE_LOCATION_TASK_LINK_REQUEST = 'CREATE_LOCATION_TASK_LINK_REQUEST';
export const CREATE_LOCATION_TASK_LINK_SUCCESS = 'CREATE_LOCATION_TASK_LINK_SUCCESS';
export const CREATE_LOCATION_TASK_LINK_FAILURE = 'CREATE_LOCATION_TASK_LINK_FAILURE';
export const UPDATE_LOCATION_TASK_LINK_REQUEST = 'UPDATE_LOCATION_TASK_LINK_REQUEST';
export const UPDATE_LOCATION_TASK_LINK_SUCCESS = 'UPDATE_LOCATION_TASK_LINK_SUCCESS';
export const UPDATE_LOCATION_TASK_LINK_FAILURE = 'UPDATE_LOCATION_TASK_LINK_FAILURE';
export const UPLOAD_LOCATION_TASK_FILE_REQUEST = 'UPLOAD_LOCATION_TASK_FILE_REQUEST';
export const UPLOAD_LOCATION_TASK_FILE_SUCCESS = 'UPLOAD_LOCATION_TASK_FILE_SUCCESS';
export const UPLOAD_LOCATION_TASK_FILE_FAILURE = 'UPLOAD_LOCATION_TASK_FILE_FAILURE';
export const UPDATE_LOCATION_TASK_FILE_REQUEST = 'UPDATE_LOCATION_TASK_FILE_REQUEST';
export const UPDATE_LOCATION_TASK_FILE_SUCCESS = 'UPDATE_LOCATION_TASK_FILE_SUCCESS';
export const UPDATE_LOCATION_TASK_FILE_FAILURE = 'UPDATE_LOCATION_TASK_FILE_FAILURE';
export const DELETE_LOCATION_TASK_FILE_REQUEST = 'DELETE_LOCATION_TASK_FILE_REQUEST';
export const DELETE_LOCATION_TASK_FILE_SUCCESS = 'DELETE_LOCATION_TASK_FILE_SUCCESS';
export const DELETE_LOCATION_TASK_FILE_FAILURE = 'DELETE_LOCATION_TASK_FILE_FAILURE';
export const CREATE_LOCATION_TASK_REQUEST = 'CREATE_LOCATION_TASK_REQUEST';
export const CREATE_LOCATION_TASK_SUCCESS = 'CREATE_LOCATION_TASK_SUCCESS';
export const CREATE_LOCATION_TASK_FAILURE = 'CREATE_LOCATION_TASK_FAILURE';
export const SEARCH_LOCATION_TASK_MENTIONABLE_USERS_REQUEST = 'SEARCH_LOCATION_TASK_MENTIONABLE_USERS_REQUEST';
export const SEARCH_LOCATION_TASK_MENTIONABLE_USERS_SUCCESS = 'SEARCH_LOCATION_TASK_MENTIONABLE_USERS_SUCCESS';
export const SEARCH_LOCATION_TASK_MENTIONABLE_USERS_FAILURE = 'SEARCH_LOCATION_TASK_MENTIONABLE_USERS_FAILURE';
export const LOAD_PROJECT_COACHES_REQUEST = 'LOAD_PROJECT_COACHES_REQUEST';
export const LOAD_PROJECT_COACHES_SUCCESS = 'LOAD_PROJECT_COACHES_SUCCESS';
export const LOAD_PROJECT_COACHES_FAILURE = 'LOAD_PROJECT_COACHES_FAILURE';
export const UPDATE_LOCATION_TASK_DATES_REQUEST = 'UPDATE_LOCATION_TASK_DATES_REQUEST';
export const UPDATE_LOCATION_TASK_DATES_SUCCESS = 'UPDATE_LOCATION_TASK_DATES_SUCCESS';
export const UPDATE_LOCATION_TASK_DATES_FAILURE = 'UPDATE_LOCATION_TASK_DATES_FAILURE';
export const UPDATE_LOCATION_CONTINGENT_REQUEST = 'UPDATE_LOCATION_CONTINGENT_REQUEST';
export const UPDATE_LOCATION_CONTINGENT_SUCCESS = 'UPDATE_LOCATION_CONTINGENT_SUCCESS';
export const UPDATE_LOCATION_CONTINGENT_FAILURE = 'UPDATE_LOCATION_CONTINGENT_FAILURE';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_REQUEST = 'LOAD_TASK_RESOURCE_ALLOCATIONS_REQUEST';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_SUCCESS = 'LOAD_TASK_RESOURCE_ALLOCATIONS_SUCCESS';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_FAILURE = 'LOAD_TASK_RESOURCE_ALLOCATIONS_FAILURE';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_REQUEST = 'LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_REQUEST';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_SUCCESS = 'LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_SUCCESS';
export const LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_FAILURE = 'LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_FAILURE';
export const CREATE_FEEDBACK_REQUEST = 'CREATE_FEEDBACK_REQUEST';
export const CREATE_FEEDBACK_SUCCESS = 'CREATE_FEEDBACK_SUCCESS';
export const CREATE_FEEDBACK_FAILURE = 'CREATE_FEEDBACK_FAILURE';
export const SET_TASK_MENU_ITEMS = 'SET_TASK_MENU_ITEMS';
export const SET_TASK_MENU_SELECTED = 'SET_TASK_MENU_SELECTED';
export const SAVE_FILTERS_REQUEST = 'SAVE_FILTERS_REQUEST';
export const SAVE_FILTERS_SUCCESS = 'SAVE_FILTERS_SUCCESS';
export const SAVE_FILTERS_FAILURE = 'SAVE_FILTERS_FAILURE';
export const SET_TASK_PAGE_TASK_MENU_ITEMS = 'SET_TASK_PAGE_TASK_MENU_ITEMS';
export const GET_CUSTOM_FILTER_REQUEST = 'GET_CUSTOM_FILTER_REQUEST';
export const GET_CUSTOM_FILTER_SUCCESS = 'GET_CUSTOM_FILTER_SUCCESS';
export const GET_CUSTOM_FILTER_FAILURE = 'GET_CUSTOM_FILTER_FAILURE';
export const DELETE_FILTER_REQUEST = 'DELETE_FILTER_REQUEST';
export const DELETE_FILTER_SUCCESS = 'DELETE_FILTER_SUCCESS';
export const DELETE_FILTER_FAILURE = 'DELETE_FILTER_FAILURE';
export const VALIDATE_TRANSLATION_TEXT_REQUEST = 'VALIDATE_TRANSLATION_TEXT_REQUEST';
export const VALIDATE_TRANSLATION_TEXT_SUCCESS = 'VALIDATE_TRANSLATION_TEXT_SUCCESS';
export const VALIDATE_TRANSLATION_TEXT_FAILURES = 'VALIDATE_TRANSLATION_TEXT_FAILURES';
export const TRANSLATE_TEXT_REQUEST = 'TRANSLATE_TEXT_REQUEST';
export const TRANSLATE_TEXT_SUCCESS = 'TRANSLATE_TEXT_SUCCESS';
export const TRANSLATE_TEXT_FAILURES = 'TRANSLATE_TEXT_FAILURES';
export const TRANSLATION_RATING_REQUEST = 'TRANSLATION_RATING_REQUEST';
export const TRANSLATION_RATING_SUCCESS = 'TRANSLATION_RATING_SUCCESS';
export const TRANSLATION_RATING_FAILURES = 'TRANSLATION_RATING_FAILURES';
export const BULK_SHIFT_DATES_REQUEST = 'BULK_SHIFT_DATES_REQUEST';
export const BULK_SHIFT_DATES_SUCCESS = 'BULK_SHIFT_DATES_SUCCESS';
export const BULK_SHIFT_DATES_FAILURE = 'BULK_SHIFT_DATES_FAILURE';

// Location Dashboard Actions
export const LOAD_LOCATION_DASHBOARD_SUMMARY_REQUEST = 'LOAD_LOCATION_DASHBOARD_SUMMARY_REQUEST';
export const LOAD_LOCATION_DASHBOARD_SUMMARY_SUCCESS = 'LOAD_LOCATION_DASHBOARD_SUMMARY_SUCCESS';
export const LOAD_LOCATION_DASHBOARD_SUMMARY_FAILURE = 'LOAD_LOCATION_DASHBOARD_SUMMARY_FAILURE';
export const LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_REQUEST = 'LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_REQUEST';
export const LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_SUCCESS = 'LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_SUCCESS';
export const LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_FAILURE = 'LOAD_LOCATION_DASHBOARD_TASK_COMPLETION_BY_FAILURE';
export const LOAD_PROJECTS_BY_LOCATION_REQUEST = 'LOAD_PROJECTS_BY_LOCATION_REQUEST';
export const LOAD_PROJECTS_BY_LOCATION_SUCCESS = 'LOAD_PROJECTS_BY_LOCATION_SUCCESS';
export const LOAD_PROJECTS_BY_LOCATION_FAILURE = 'LOAD_PROJECTS_BY_LOCATION_FAILURE';
export const LOAD_PROJECT_WIDGET_DRAWER_FILTERS_REQUEST = 'LOAD_PROJECT_WIDGET_DRAWER_FILTERS_REQUEST';
export const LOAD_PROJECT_WIDGET_DRAWER_FILTERS_SUCCESS = 'LOAD_PROJECT_WIDGET_DRAWER_FILTERS_SUCCESS';
export const LOAD_PROJECT_WIDGET_DRAWER_FILTERS_FAILURE = 'LOAD_PROJECT_WIDGET_DRAWER_FILTERS_FAILURE';
export const LOAD_MILESTONES_BY_LOCATION_REQUEST = 'LOAD_MILESTONES_BY_LOCATION_REQUEST';
export const LOAD_MILESTONES_BY_LOCATION_SUCCESS = 'LOAD_MILESTONES_BY_LOCATION_SUCCESS';
export const LOAD_MILESTONES_BY_LOCATION_FAILURE = 'LOAD_MILESTONES_BY_LOCATION_FAILURE';
export const LOAD_MILESTONES_LISTING_REQUEST = 'LOAD_MILESTONES_LISTING_REQUEST';
export const LOAD_MILESTONES_LISTING_SUCCESS = 'LOAD_MILESTONES_LISTING_SUCCESS';
export const LOAD_MILESTONES_LISTING_FAILURE = 'LOAD_MILESTONES_LISTING_FAILURE';
export const LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_REQUEST = 'LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_REQUEST';
export const LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_SUCCESS = 'LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_SUCCESS';
export const LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_FAILURE = 'LOAD_MILESTONE_TASKS_WITH_PREREQUISITES_FAILURE';
export const LOAD_LOCATION_DASHBOARD_FILES_REQUEST = 'LOAD_LOCATION_DASHBOARD_FILES_REQUEST';
export const LOAD_LOCATION_DASHBOARD_FILES_SUCCESS = 'LOAD_LOCATION_DASHBOARD_FILES_SUCCESS';
export const LOAD_LOCATION_DASHBOARD_FILES_FAILURE = 'LOAD_LOCATION_DASHBOARD_FILES_FAILURE';
export const LOAD_LOCATION_GOALS_REQUEST = 'LOAD_LOCATION_GOALS_REQUEST';
export const LOAD_LOCATION_GOALS_SUCCESS = 'LOAD_LOCATION_GOALS_SUCCESS';
export const LOAD_LOCATION_GOALS_FAILURE = 'LOAD_LOCATION_GOALS_FAILURE';
export const SAVE_LOCATION_GOALS_REQUEST = 'SAVE_LOCATION_GOALS_REQUEST';
export const SAVE_LOCATION_GOALS_SUCCESS = 'SAVE_LOCATION_GOALS_SUCCESS';
export const SAVE_LOCATION_GOALS_FAILURE = 'SAVE_LOCATION_GOALS_FAILURE';
export const LOAD_EXTERNAL_TASK_COMPLETION_BY_REQUEST = 'LOAD_EXTERNAL_TASK_COMPLETION_BY_REQUEST';
export const LOAD_EXTERNAL_TASK_COMPLETION_BY_SUCCESS = 'LOAD_EXTERNAL_TASK_COMPLETION_BY_SUCCESS';
export const LOAD_EXTERNAL_TASK_COMPLETION_BY_FAILURE = 'LOAD_EXTERNAL_TASK_COMPLETION_BY_FAILURE';
export const LOAD_TASK_ASSIGNMENT_COUNTS_REQUEST = 'LOAD_TASK_ASSIGNMENT_COUNTS_REQUEST';
export const LOAD_TASK_ASSIGNMENT_COUNTS_SUCCESS = 'LOAD_TASK_ASSIGNMENT_COUNTS_SUCCESS';
export const LOAD_TASK_ASSIGNMENT_COUNTS_FAILURE = 'LOAD_TASK_ASSIGNMENT_COUNTS_FAILURE';
export const LOAD_TASK_ASSIGNMENT_FILTERS_REQUEST = 'LOAD_TASK_ASSIGNMENT_FILTERS_REQUEST';
export const LOAD_TASK_ASSIGNMENT_FILTERS_SUCCESS = 'LOAD_TASK_ASSIGNMENT_FILTERS_SUCCESS';
export const LOAD_TASK_ASSIGNMENT_FILTERS_FAILURE = 'LOAD_TASK_ASSIGNMENT_FILTERS_FAILURE';
export const SAVE_TASK_ASSIGNMENTS_REQUEST = 'SAVE_TASK_ASSIGNMENTS_REQUEST';
export const SAVE_TASK_ASSIGNMENTS_SUCCESS = 'SAVE_TASK_ASSIGNMENTS_SUCCESS';
export const SAVE_TASK_ASSIGNMENTS_FAILURE = 'SAVE_TASK_ASSIGNMENTS_FAILURE';
export const LOAD_TASK_REASSIGNMENTS_REQUEST = 'LOAD_TASK_REASSIGNMENTS_REQUEST';
export const LOAD_TASK_REASSIGNMENTS_SUCCESS = 'LOAD_TASK_REASSIGNMENTS_SUCCESS';
export const LOAD_TASK_REASSIGNMENTS_FAILURE = 'LOAD_TASK_REASSIGNMENTS_FAILURE';
export const LOAD_LOCATION_FINANCIALS_SPREADSHEET_REQUEST = 'LOAD_LOCATION_FINANCIALS_SPREADSHEET_REQUEST';
export const LOAD_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS = 'LOAD_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS';
export const LOAD_LOCATION_FINANCIALS_SPREADSHEET_FAILURE = 'LOAD_LOCATION_FINANCIALS_SPREADSHEET_FAILURE';
export const SAVE_LOCATION_FINANCIALS_SPREADSHEET_REQUEST = 'SAVE_LOCATION_FINANCIALS_SPREADSHEET_REQUEST';
export const SAVE_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS = 'SAVE_LOCATION_FINANCIALS_SPREADSHEET_SUCCESS';
export const SAVE_LOCATION_FINANCIALS_SPREADSHEET_FAILURE = 'SAVE_LOCATION_FINANCIALS_SPREADSHEET_FAILURE';
export const LOAD_FINANCIALS_SUMMARY_REQUEST = 'LOAD_FINANCIALS_SUMMARY_REQUEST';
export const LOAD_FINANCIALS_SUMMARY_SUCCESS = 'LOAD_FINANCIALS_SUMMARY_SUCCESS';
export const LOAD_FINANCIALS_SUMMARY_FAILURE = 'LOAD_FINANCIALS_SUMMARY_FAILURE';
export const CREATE_SINGLE_LOCATION_PROJECT_REQUEST = 'CREATE_SINGLE_LOCATION_PROJECT_REQUEST';
export const CREATE_SINGLE_LOCATION_PROJECT_SUCCESS = 'CREATE_SINGLE_LOCATION_PROJECT_SUCCESS';
export const CREATE_SINGLE_LOCATION_PROJECT_FAILURE = 'CREATE_SINGLE_LOCATION_PROJECT_FAILURE';
export const LOAD_SINGLE_PROJECT_DRAWER_FILTERS_REQUEST = 'LOAD_SINGLE_PROJECT_DRAWER_FILTERS_REQUEST';
export const LOAD_SINGLE_PROJECT_DRAWER_FILTERS_SUCCESS = 'LOAD_SINGLE_PROJECT_DRAWER_FILTERS_SUCCESS';
export const LOAD_SINGLE_PROJECT_DRAWER_FILTERS_FAILURE = 'LOAD_SINGLE_PROJECT_DRAWER_FILTERS_FAILURE';

// Project Manager Dashboard Actions
export const LOAD_PROJECTMGR_DASHBOARD_SUMMARY_REQUEST = 'LOAD_PROJECTMGR_DASHBOARD_SUMMARY_REQUEST';
export const LOAD_PROJECTMGR_DASHBOARD_SUMMARY_SUCCESS = 'LOAD_PROJECTMGR_DASHBOARD_SUMMARY_SUCCESS';
export const LOAD_PROJECTMGR_DASHBOARD_SUMMARY_FAILURE = 'LOAD_PROJECTMGR_DASHBOARD_SUMMARY_FAILURE';
export const LOAD_PROJECT_BASELINES_REQUEST = 'LOAD_PROJECT_BASELINES_REQUEST';
export const LOAD_PROJECT_BASELINES_SUCCESS = 'LOAD_PROJECT_BASELINES_SUCCESS';
export const LOAD_PROJECT_BASELINES_FAILURE = 'LOAD_PROJECT_BASELINES_FAILURE';
export const LOAD_PROJECT_BASELINES_REQUEST_V2 = 'LOAD_PROJECT_BASELINES_REQUEST_V2';
export const LOAD_PROJECT_BASELINES_SUCCESS_V2 = 'LOAD_PROJECT_BASELINES_SUCCESS_V2';
export const LOAD_PROJECT_BASELINES_FAILURE_V2 = 'LOAD_PROJECT_BASELINES_FAILURE_V2';
export const CREATE_PROJECT_BASELINE_REQUEST = 'CREATE_PROJECT_BASELINE_REQUEST';
export const CREATE_PROJECT_BASELINE_SUCCESS = 'CREATE_PROJECT_BASELINE_SUCCESS';
export const CREATE_PROJECT_BASELINE_FAILURE = 'CREATE_PROJECT_BASELINE_FAILURE';
export const LINK_PROJECT_BASELINE_REQUEST = 'LINK_PROJECT_BASELINE_REQUEST';
export const LINK_PROJECT_BASELINE_SUCCESS = 'LINK_PROJECT_BASELINE_SUCCESS';
export const LINK_PROJECT_BASELINE_FAILURE = 'LINK_PROJECT_BASELINE_FAILURE';
export const LOAD_PROJECT_BASELINE_FILTERS_REQUEST = 'LOAD_PROJECT_BASELINE_FILTERS_REQUEST';
export const LOAD_PROJECT_BASELINE_FILTERS_SUCCESS = 'LOAD_PROJECT_BASELINE_FILTERS_SUCCESS';
export const LOAD_PROJECT_BASELINE_FILTERS_FAILURE = 'LOAD_PROJECT_BASELINE_FILTERS_FAILURE';
export const LOAD_PROJECT_FILES_FILTERS_REQUEST = 'LOAD_PROJECT_FILES_FILTERS_REQUEST';
export const LOAD_PROJECT_FILES_FILTERS_SUCCESS = 'LOAD_PROJECT_FILES_FILTERS_SUCCESS';
export const LOAD_PROJECT_FILES_FILTERS_FAILURE = 'LOAD_PROJECT_FILES_FILTERS_FAILURE';
export const SEARCH_PROJECT_FILES_REQUEST = 'SEARCH_PROJECT_FILES_REQUEST';
export const SEARCH_PROJECT_FILES_SUCCESS = 'SEARCH_PROJECT_FILES_SUCCESS';
export const SEARCH_PROJECT_FILES_FAILURE = 'SEARCH_PROJECT_FILES_FAILURE';
export const UPDATE_PROJECT_FILES_APPROVE_REQUEST = 'UPDATE_PROJECT_FILES_APPROVE_REQUEST';
export const UPDATE_PROJECT_FILES_APPROVE_SUCCESS = 'UPDATE_PROJECT_FILES_APPROVE_SUCCESS';
export const UPDATE_PROJECT_FILES_APPROVE_FAILURE = 'UPDATE_PROJECT_FILES_APPROVE_FAILURE';
export const UPDATE_PROJECT_FILES_DENY_REQUEST = 'UPDATE_PROJECT_FILES_DENY_REQUEST';
export const UPDATE_PROJECT_FILES_DENY_SUCCESS = 'UPDATE_PROJECT_FILES_DENY_SUCCESS';
export const UPDATE_PROJECT_FILES_DENY_FAILURE = 'UPDATE_PROJECT_FILES_DENY_FAILURE';
export const SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_REQUEST = 'SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_REQUEST';
export const SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_SUCCESS = 'SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_SUCCESS';
export const SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_FAILURE = 'SEARCH_PROJECT_FILES_BULK_REASSIGN_FILTERS_FAILURE';
export const UPDATE_PROJECT_FILES_REASSIGN_REQUEST = 'UPDATE_PROJECT_FILES_REASSIGN_REQUEST';
export const UPDATE_PROJECT_FILES_REASSIGN_SUCCESS = 'UPDATE_PROJECT_FILES_REASSIGN_SUCCESS';
export const UPDATE_PROJECT_FILES_REASSIGN_FAILURE = 'UPDATE_PROJECT_FILES_REASSIGN_FAILURE';
export const BULK_DOWNLOAD_PROJECT_FILES_REQUEST = 'BULK_DOWNLOAD_PROJECT_FILES_REQUEST';
export const BULK_DOWNLOAD_PROJECT_FILES_SUCCESS = 'BULK_DOWNLOAD_PROJECT_FILES_SUCCESS';
export const BULK_DOWNLOAD_PROJECT_FILES_FAILURE = 'BULK_DOWNLOAD_PROJECT_FILES_FAILURE';
export const LOAD_PROJECT_ALL_TASKS_GRAPH_REQUEST = 'LOAD_PROJECT_ALL_TASKS_GRAPH_REQUEST';
export const LOAD_PROJECT_ALL_TASKS_GRAPH_SUCCESS = 'LOAD_PROJECT_ALL_TASKS_GRAPH_SUCCESS';
export const LOAD_PROJECT_ALL_TASKS_GRAPH_FAILURE = 'LOAD_PROJECT_ALL_TASKS_GRAPH_FAILURE';
export const LOAD_PROJECT_MILESTONE_TASKS_GRAPH_REQUEST = 'LOAD_PROJECT_MILESTONE_TASKS_GRAPH_REQUEST';
export const LOAD_PROJECT_MILESTONE_TASKS_GRAPH_SUCCESS = 'LOAD_PROJECT_MILESTONE_TASKS_GRAPH_SUCCESS';
export const LOAD_PROJECT_MILESTONE_TASKS_GRAPH_FAILURE = 'LOAD_PROJECT_MILESTONE_TASKS_GRAPH_FAILURE';
export const LOAD_PROJECT_COACH_TASKS_GRAPH_REQUEST = 'LOAD_PROJECT_COACH_TASKS_GRAPH_REQUEST';
export const LOAD_PROJECT_COACH_TASKS_GRAPH_SUCCESS = 'LOAD_PROJECT_COACH_TASKS_GRAPH_SUCCESS';
export const LOAD_PROJECT_COACH_TASKS_GRAPH_FAILURE = 'LOAD_PROJECT_COACH_TASKS_GRAPH_FAILURE';
export const LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_REQUEST = 'LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_REQUEST';
export const LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_SUCCESS = 'LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_SUCCESS';
export const LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_FAILURE = 'LOAD_PROJECT_CERTIFIED_TASKS_GRAPH_FAILURE';
export const SAVE_LOCATIONS_COLUMNS_REQUEST = 'SAVE_LOCATIONS_COLUMNS_REQUEST';
export const SAVE_LOCATIONS_COLUMNS_SUCCESS = 'SAVE_LOCATIONS_COLUMNS_SUCCESS';
export const SAVE_LOCATIONS_COLUMNS_FAILURE = 'SAVE_LOCATIONS_COLUMNS_FAILURE';
export const SAVE_TASKS_COLUMNS_REQUEST = 'SAVE_TASKS_COLUMNS_REQUEST';
export const SAVE_TASKS_COLUMNS_SUCCESS = 'SAVE_TASKS_COLUMNS_SUCCESS';
export const SAVE_TASKS_COLUMNS_FAILURE = 'SAVE_TASKS_COLUMNS_FAILURE';
export const SAVE_USER_COLUMNS_REQUEST = 'SAVE_USER_COLUMNS_REQUEST';
export const SAVE_USER_COLUMNS_SUCCESS = 'SAVE_USER_COLUMNS_SUCCESS';
export const SAVE_USER_COLUMNS_FAILURE = 'SAVE_USER_COLUMNS_FAILURE';
export const UNLINK_BASELINE_REQUEST = 'UNLINK_BASELINE_REQUEST';
export const UNLINK_BASELINE_SUCCESS = 'UNLINK_BASELINE_SUCCESS';
export const UNLINK_BASELINE_FAILURE = 'UNLINK_BASELINE_FAILURE';

// Navigation Actions
export const LOAD_NAVIGATION_INFO_REQUEST = 'LOAD_NAVIGATION_INFO_REQUEST';
export const LOAD_NAVIGATION_INFO_SUCCESS = 'LOAD_NAVIGATION_INFO_SUCCESS';
export const LOAD_NAVIGATION_INFO_FAILURE = 'LOAD_NAVIGATION_INFO_FAILURE';
export const SET_NAV_SUBSCRIPTION_LOGO = 'SET_NAV_SUBSCRIPTION_LOGO';
export const LOAD_TASKS_MENU_REQUEST = 'LOAD_TASKS_MENU_REQUEST';
export const LOAD_TASKS_MENU_SUCCESS = 'LOAD_TASKS_MENU_SUCCESS';
export const LOAD_TASKS_MENU_FAILURE = 'LOAD_TASKS_MENU_FAILURE';

// Reports Actions
export const SEARCH_REPORTS_REQUEST = 'SEARCH_REPORTS_REQUEST';
export const SEARCH_REPORTS_SUCCESS = 'SEARCH_REPORTS_SUCCESS';
export const SEARCH_REPORTS_FAILURE = 'SEARCH_REPORTS_FAILURE';
export const LOAD_REPORT_FILTERS_REQUEST = 'LOAD_REPORT_FILTERS_REQUEST';
export const LOAD_REPORT_FILTERS_SUCCESS = 'LOAD_REPORT_FILTERS_SUCCESS';
export const LOAD_REPORT_FILTERS_FAILURE = 'LOAD_REPORT_FILTERS_FAILURE';
export const SAVE_REPORT_FILTER_VALUES = 'SAVE_REPORT_FILTERS';
export const VIEW_REPORT_REQUEST = 'VIEW_REPORT_REQUEST';
export const VIEW_REPORT_SUCCESS = 'VIEW_REPORT_SUCCESS';
export const VIEW_REPORT_FAILURE = 'VIEW_REPORT_FAILURE';
export const LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_REQUEST = 'LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_REQUEST';
export const LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_SUCCESS = 'LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_SUCCESS';
export const LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_FAILURE = 'LOAD_REPORT_LOCATION_RESPONSIBLE_USERS_FAILURE';
export const LOAD_SCHEDULE_FILTERS_REQUEST = 'LOAD_SCHEDULE_FILTERS_REQUEST';
export const LOAD_SCHEDULE_FILTERS_SUCCESS = 'LOAD_SCHEDULE_FILTERS_SUCCESS';
export const LOAD_SCHEDULE_FILTERS_FAILURE = 'LOAD_SCHEDULE_FILTERS_FAILURE';
export const CREATE_SCHEDULED_REPORT_REQUEST = 'CREATE_SCHEDULED_REPORT_REQUEST';
export const CREATE_SCHEDULED_REPORT_SUCCESS = 'CREATE_SCHEDULED_REPORT_SUCCESS';
export const CREATE_SCHEDULED_REPORT_FAILURE = 'CREATE_SCHEDULED_REPORT_FAILURE';
export const LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_REQUEST = 'LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_REQUEST';
export const LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_SUCCESS = 'LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_SUCCESS';
export const LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_FAILURE = 'LOAD_REPORT_PROJECT_DEPENDENT_FILTERS_FAILURE';
export const LOAD_SCHEDULED_REPORTS_REQUEST = 'LOAD_SCHEDULED_REPORTS_REQUEST';
export const LOAD_SCHEDULED_REPORTS_SUCCESS = 'LOAD_SCHEDULED_REPORTS_SUCCESS';
export const LOAD_SCHEDULED_REPORTS_FAILURE = 'LOAD_SCHEDULED_REPORTS_FAILURE';
export const DELETE_SCHEDULED_REPORT_REQUEST = 'DELETE_SCHEDULED_REPORT_REQUEST';
export const DELETE_SCHEDULED_REPORT_SUCCESS = 'DELETE_SCHEDULED_REPORT_SUCCESS';
export const DELETE_SCHEDULED_REPORT_FAILURE = 'DELETE_SCHEDULED_REPORT_FAILURE';
export const LOAD_SCHEDULED_REPORT_REQUEST = 'LOAD_SCHEDULED_REPORT_REQUEST';
export const LOAD_SCHEDULED_REPORT_SUCCESS = 'LOAD_SCHEDULED_REPORT_SUCCESS';
export const LOAD_SCHEDULED_REPORT_FAILURE = 'LOAD_SCHEDULED_REPORT_FAILURE';
export const UPDATE_SCHEDULED_REPORT_REQUEST = 'UPDATE_SCHEDULED_REPORT_REQUEST';
export const UPDATE_SCHEDULED_REPORT_SUCCESS = 'UPDATE_SCHEDULED_REPORT_SUCCESS';
export const UPDATE_SCHEDULED_REPORT_FAILURE = 'UPDATE_SCHEDULED_REPORT_FAILURE';
export const LOAD_COACH_LOCATIONS_FILTERS_REQUEST = 'LOAD_COACH_LOCATIONS_FILTERS_REQUEST';
export const LOAD_COACH_LOCATIONS_FILTERS_SUCCESS = 'LOAD_COACH_LOCATIONS_FILTERS_SUCCESS';
export const LOAD_COACH_LOCATIONS_FILTERS_FAILURE = 'LOAD_COACH_LOCATIONS_FILTERS_FAILURE';

// Company Dashboard Actions
export const LOAD_COMPANY_DASHBOARD_FILTERS_REQUEST = 'LOAD_COMPANY_DASHBOARD_FILTERS_REQUEST';
export const LOAD_COMPANY_DASHBOARD_FILTERS_SUCCESS = 'LOAD_COMPANY_DASHBOARD_FILTERS_SUCCESS';
export const LOAD_COMPANY_DASHBOARD_FILTERS_FAILURE = 'LOAD_COMPANY_DASHBOARD_FILTERS_FAILURE';
export const LOAD_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'LOAD_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const LOAD_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'LOAD_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const LOAD_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'LOAD_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const SAVE_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'SAVE_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const SAVE_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'SAVE_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const SAVE_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'SAVE_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const LIST_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'LIST_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const LIST_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'LIST_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const LIST_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'LIST_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'SAVE_CUSTOM_VIEWS_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const UPDATE_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'UPDATE_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const UPDATE_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'UPDATE_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const UPDATE_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'UPDATE_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const CHECK_COMPANY_DASHBOARD_SETTINGS_REQUEST = 'CHECK_COMPANY_DASHBOARD_SETTINGS_REQUEST';
export const CHECK_COMPANY_DASHBOARD_SETTINGS_SUCCESS = 'CHECK_COMPANY_DASHBOARD_SETTINGS_SUCCESS';
export const CHECK_COMPANY_DASHBOARD_SETTINGS_FAILURE = 'CHECK_COMPANY_DASHBOARD_SETTINGS_FAILURE';
export const LOAD_COMPANY_DASHBOARD_LOCSUMMARY_REQUEST = 'LOAD_COMPANY_DASHBOARD_LOCSUMMARY_REQUEST';
export const LOAD_COMPANY_DASHBOARD_LOCSUMMARY_SUCCESS = 'LOAD_COMPANY_DASHBOARD_LOCSUMMARY_SUCCESS';
export const LOAD_COMPANY_DASHBOARD_LOCSUMMARY_FAILURE = 'LOAD_COMPANY_DASHBOARD_LOCSUMMARY_FAILURE';
export const LOAD_COMPANY_DASHBOARD_PROJECTS_REQUEST = 'LOAD_COMPANY_DASHBOARD_PROJECTS_REQUEST';
export const LOAD_COMPANY_DASHBOARD_PROJECTS_SUCCESS = 'LOAD_COMPANY_DASHBOARD_PROJECTS_SUCCESS';
export const LOAD_COMPANY_DASHBOARD_PROJECTS_FAILURE = 'LOAD_COMPANY_DASHBOARD_PROJECTS_FAILURE';
export const LOAD_COMPANY_DASHBOARD_LOCATIONS_REQUEST = 'LOAD_COMPANY_DASHBOARD_LOCATIONS_REQUEST';
export const LOAD_COMPANY_DASHBOARD_LOCATIONS_SUCCESS = 'LOAD_COMPANY_DASHBOARD_LOCATIONS_SUCCESS';
export const LOAD_COMPANY_DASHBOARD_LOCATIONS_FAILURE = 'LOAD_COMPANY_DASHBOARD_LOCATIONS_FAILURE';
export const LOAD_MISSED_MILESTONES_REQUEST = 'LOAD_MISSED_MILESTONES_REQUEST';
export const LOAD_MISSED_MILESTONES_SUCCESS = 'LOAD_MISSED_MILESTONES_SUCCESS';
export const LOAD_MISSED_MILESTONES_FAILURE = 'LOAD_MISSED_MILESTONES_FAILURE';
export const LOAD_UPCOMING_TASKS_REQUEST = 'LOAD_UPCOMING_TASKS_REQUEST';
export const LOAD_UPCOMING_TASKS_SUCCESS = 'LOAD_UPCOMING_TASKS_SUCCESS';
export const LOAD_UPCOMING_TASKS_FAILURE = 'LOAD_UPCOMING_TASKS_FAILURE';
export const LOAD_WORKLOAD_RESULTS_REQUEST = 'LOAD_WORKLOAD_RESULTS_REQUEST';
export const LOAD_WORKLOAD_RESULTS_SUCCESS = 'LOAD_WORKLOAD_RESULTS_SUCCESS';
export const LOAD_WORKLOAD_RESULTS_FAILURE = 'LOAD_WORKLOAD_RESULTS_FAILURE';
export const GET_WORKLOAD_DETAILS_REQUEST = 'GET_WORKLOAD_DETAILS_REQUEST';
export const GET_WORKLOAD_DETAILS_SUCCESS = 'GET_WORKLOAD_DETAILS_SUCCESS';
export const GET_WORKLOAD_DETAILS_FAILURE = 'GET_WORKLOAD_DETAILS_FAILURE';
export const SET_OVERVIEW_TAB_REQUEST = 'SET_OVERVIEW_TAB_REQUEST';
export const SET_OVERVIEW_TAB_SUCCESS = 'SET_OVERVIEW_TAB_SUCCESS';
export const SET_OVERVIEW_TAB_FAILURE = 'SET_OVERVIEW_TAB_FAILURE';
export const GET_PROJECT_PARAMS_REQUEST = 'GET_PROJECT_PARAMS_REQUEST';
export const GET_PROJECT_PARAMS_SUCCESS = 'GET_PROJECT_PARAMS_SUCCESS';
export const GET_PROJECT_PARAMS_FAILURE = 'GET_PROJECT_PARAMS_FAILURE';
export const GET_OVERVIEW_TABS_CONFIG_REQUEST = 'GET_OVERVIEW_TABS_CONFIG_REQUEST';
export const GET_OVERVIEW_TABS_CONFIG_SUCCESS = 'GET_OVERVIEW_TABS_CONFIG_SUCCESS';
export const GET_OVERVIEW_TABS_CONFIG_FAILURE = 'GET_OVERVIEW_TABS_CONFIG_FAILURE';
export const UPDATE_OVERVIEW_TABS_CONFIG_REQUEST = 'UPDATE_OVERVIEW_TABS_CONFIG_REQUEST';
export const UPDATE_OVERVIEW_TABS_CONFIG_SUCCESS = 'UPDATE_OVERVIEW_TABS_CONFIG_SUCCESS';
export const UPDATE_OVERVIEW_TABS_CONFIG_FAILURE = 'UPDATE_OVERVIEW_TABS_CONFIG_FAILURE';
export const GET_TAB_REQUEST = 'GET_TAB_REQUEST';
export const GET_TAB_SUCCESS = 'GET_TAB_SUCCESS';
export const GET_TAB_FAILURE = 'GET_TAB_FAILURE';
export const GET_LOAD_LOCATIONS_BY_PROJECT_REQUEST = 'GET_LOAD_LOCATIONS_BY_PROJECT_REQUEST';
export const GET_LOAD_LOCATIONS_BY_PROJECT_SUCCESS = 'GET_LOAD_LOCATIONS_BY_PROJECT_SUCCESS';
export const GET_LOAD_LOCATIONS_BY_PROJECT_FAILURE = 'GET_LOAD_LOCATIONS_BY_PROJECT_FAILURE';

// Location File Actions
export const LOAD_LOCATION_FILE_FILTERS_REQUEST = 'LOAD_LOCATION_FILE_FILTERS_REQUEST';
export const LOAD_LOCATION_FILE_FILTERS_SUCCESS = 'LOAD_LOCATION_FILE_FILTERS_SUCCESS';
export const LOAD_LOCATION_FILE_FILTERS_FAILURE = 'LOAD_LOCATION_FILE_FILTERS_FAILURE';
export const LOAD_LOCATION_FILE_TASK_FILTERS_REQUEST = 'LOAD_LOCATION_FILE_TASK_FILTERS_REQUEST';
export const LOAD_LOCATION_FILE_TASK_FILTERS_SUCCESS = 'LOAD_LOCATION_FILE_TASK_FILTERS_SUCCESS';
export const LOAD_LOCATION_FILE_TASK_FILTERS_FAILURE = 'LOAD_LOCATION_FILE_TASK_FILTERS_FAILURE';

// User Tag Actions
export const SEARCH_USER_TAGS_REQUEST = 'SEARCH_USER_TAGS_REQUEST';
export const SEARCH_USER_TAGS_SUCCESS = 'SEARCH_USER_TAGS_SUCCESS';
export const SEARCH_USER_TAGS_FAILURE = 'SEARCH_USER_TAGS_FAILURE';
export const CREATE_USER_TAG_REQUEST = 'CREATE_USER_TAG_REQUEST';
export const CREATE_USER_TAG_SUCCESS = 'CREATE_USER_TAG_SUCCESS';
export const CREATE_USER_TAG_FAILURE = 'CREATE_USER_TAG_FAILURE';
export const UPDATE_USER_TAG_REQUEST = 'UPDATE_USER_TAG_REQUEST';
export const UPDATE_USER_TAG_SUCCESS = 'UPDATE_USER_TAG_SUCCESS';
export const UPDATE_USER_TAG_FAILURE = 'UPDATE_USER_TAG_FAILURE';

// Location Tag Actions
export const SEARCH_LOCATION_TAGS_REQUEST = 'SEARCH_LOCATION_TAGS_REQUEST';
export const SEARCH_LOCATION_TAGS_SUCCESS = 'SEARCH_LOCATION_TAGS_SUCCESS';
export const SEARCH_LOCATION_TAGS_FAILURE = 'SEARCH_LOCATION_TAGS_FAILURE';
export const CREATE_LOCATION_TAG_REQUEST = 'CREATE_LOCATION_TAG_REQUEST';
export const CREATE_LOCATION_TAG_SUCCESS = 'CREATE_LOCATION_TAG_SUCCESS';
export const CREATE_LOCATION_TAG_FAILURE = 'CREATE_LOCATION_TAG_FAILURE';
export const UPDATE_LOCATION_TAG_REQUEST = 'UPDATE_LOCATION_TAG_REQUEST';
export const UPDATE_LOCATION_TAG_SUCCESS = 'UPDATE_LOCATION_TAG_SUCCESS';
export const UPDATE_LOCATION_TAG_FAILURE = 'UPDATE_LOCATION_TAG_FAILURE';

// Task Tag Actions
export const SEARCH_TASK_TAGS_REQUEST = 'SEARCH_TASK_TAGS_REQUEST';
export const SEARCH_TASK_TAGS_SUCCESS = 'SEARCH_TASK_TAGS_SUCCESS';
export const SEARCH_TASK_TAGS_FAILURE = 'SEARCH_TASK_TAGS_FAILURE';
export const CREATE_TASK_TAG_REQUEST = 'CREATE_TASK_TAG_REQUEST';
export const CREATE_TASK_TAG_SUCCESS = 'CREATE_TASK_TAG_SUCCESS';
export const CREATE_TASK_TAG_FAILURE = 'CREATE_TASK_TAG_FAILURE';
export const UPDATE_TASK_TAG_REQUEST = 'UPDATE_TASK_TAG_REQUEST';
export const UPDATE_TASK_TAG_SUCCESS = 'UPDATE_TASK_TAG_SUCCESS';
export const UPDATE_TASK_TAG_FAILURE = 'UPDATE_TASK_TAG_FAILURE';

// Tool Tip Actions
export const SEARCH_TOOL_TIPS_REQUEST = 'SEARCH_TOOL_TIPS_REQUEST';
export const SEARCH_TOOL_TIPS_SUCCESS = 'SEARCH_TOOL_TIPS_SUCCESS';
export const SEARCH_TOOL_TIPS_FAILURE = 'SEARCH_TOOL_TIPS_FAILURE';
export const CREATE_TOOL_TIPS_REQUEST = 'CREATE_TOOL_TIPS_REQUEST';
export const CREATE_TOOL_TIPS_SUCCESS = 'CREATE_TOOL_TIPS_SUCCESS';
export const CREATE_TOOL_TIPS_FAILURE = 'CREATE_TOOL_TIPS_FAILURE';
export const UPDATE_TOOL_TIPS_REQUEST = 'UPDATE_TOOL_TIPS_REQUEST';
export const UPDATE_TOOL_TIPS_SUCCESS = 'UPDATE_TOOL_TIPS_SUCCESS';
export const UPDATE_TOOL_TIPS_FAILURE = 'UPDATE_TOOL_TIPS_FAILURE';
export const LOAD_TOOL_TIPS_FILTERS_REQUEST = 'LOAD_TOOL_TIPS_FILTERS_REQUEST';
export const LOAD_TOOL_TIPS_FILTERS_SUCCESS = 'LOAD_TOOL_TIPS_FILTERS_SUCCESS';
export const LOAD_TOOL_TIPS_FILTERS_FAILURE = 'LOAD_TOOL_TIPS_FILTERS_FAILURE';
export const DISMISS_TOOL_TIP_REQUEST = 'DISMISS_TOOL_TIP_REQUEST';
export const DISMISS_TOOL_TIP_SUCCESS = 'DISMISS_TOOL_TIP_SUCCESS';
export const DISMISS_TOOL_TIP_FAILURE = 'DISMISS_TOOL_TIP_FAILURE';

// Web Assets Actions
export const SEARCH_WEB_ASSETS_REQUEST = 'SEARCH_WEB_ASSETS_REQUEST';
export const SEARCH_WEB_ASSETS_SUCCESS = 'SEARCH_WEB_ASSETS_SUCCESS';
export const SEARCH_WEB_ASSETS_FAILURE = 'SEARCH_WEB_ASSETS_FAILURE';
export const UPLOAD_WEB_ASSETS_REQUEST = 'UPLOAD_WEB_ASSETS_REQUEST';
export const UPLOAD_WEB_ASSETS_SUCCESS = 'UPLOAD_WEB_ASSETS_SUCCESS';
export const UPLOAD_WEB_ASSETS_FAILURE = 'UPLOAD_WEB_ASSETS_FAILURE';
export const DELETE_WEB_ASSETS_REQUEST = 'DELETE_WEB_ASSETS_REQUEST';
export const DELETE_WEB_ASSETS_SUCCESS = 'DELETE_WEB_ASSETS_SUCCESS';
export const DELETE_WEB_ASSETS_FAILURE = 'DELETE_WEB_ASSETS_FAILURE';

// New Project Wizard Actions
export const NEW_PROJECT_WIZARD_DETAILS_FILTERS_REQUEST = 'NEW_PROJECT_WIZARD_DETAILS_FILTERS_REQUEST';
export const NEW_PROJECT_WIZARD_DETAILS_FILTERS_SUCCESS = 'NEW_PROJECT_WIZARD_DETAILS_FILTERS_SUCCESS';
export const NEW_PROJECT_WIZARD_DETAILS_FILTERS_FAILURE = 'NEW_PROJECT_WIZARD_DETAILS_FILTERS_FAILURE';
export const NEW_PROJECT_WIZARD_LOCATION_SEARCH_REQUEST = 'NEW_PROJECT_WIZARD_LOCATION_SEARCH_REQUEST';
export const NEW_PROJECT_WIZARD_LOCATION_SEARCH_SUCCESS = 'NEW_PROJECT_WIZARD_LOCATION_SEARCH_SUCCESS';
export const NEW_PROJECT_WIZARD_LOCATION_SEARCH_FAILURE = 'NEW_PROJECT_WIZARD_LOCATION_SEARCH_FAILURE';
export const NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_REQUEST = 'NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_REQUEST';
export const NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_SUCCESS = 'NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_SUCCESS';
export const NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_FAILURE = 'NEW_PROJECT_WIZARD_LIST_LINK_BASELINES_FAILURE';
export const NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_REQUEST = 'NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_REQUEST';
export const NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_SUCCESS = 'NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_SUCCESS';
export const NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_FAILURE = 'NEW_PROJECT_WIZARD_LIST_COPY_BASELINES_FAILURE';
export const NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_REQUEST = 'NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_REQUEST';
export const NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_SUCCESS = 'NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_SUCCESS';
export const NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_FAILURE = 'NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_FAILURE';
export const NEW_PROJECT_WIZARD_IMPORT_BASELINE_REQUEST = 'NEW_PROJECT_WIZARD_IMPORT_BASELINE_REQUEST';
export const NEW_PROJECT_WIZARD_IMPORT_BASELINE_SUCCESS = 'NEW_PROJECT_WIZARD_IMPORT_BASELINE_SUCCESS';
export const NEW_PROJECT_WIZARD_IMPORT_BASELINE_FAILURE = 'NEW_PROJECT_WIZARD_IMPORT_BASELINE_FAILURE';
export const NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_REQUEST = 'NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_REQUEST';
export const NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_SUCCESS = 'NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_SUCCESS';
export const NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_FAILURE = 'NEW_PROJECT_WIZARD_CREATE_BASELINE_TASK_FAILURE';
export const LOAD_NEW_PROJECT_FORM_FILTERS_REQUEST = 'LOAD_NEW_PROJECT_FORM_FILTERS_REQUEST';
export const LOAD_NEW_PROJECT_FORM_FILTERS_SUCCESS = 'LOAD_NEW_PROJECT_FORM_FILTERS_SUCCESS';
export const LOAD_NEW_PROJECT_FORM_FILTERS_FAILURE = 'LOAD_NEW_PROJECT_FORM_FILTERS_FAILURE';

// New My Workspace Actions
export const MY_WORKSPACE_LOAD_DEFAULT_STATUSES_REQUEST = 'MY_WORKSPACE_LOAD_DEFAULT_STATUSES_REQUEST';
export const MY_WORKSPACE_LOAD_DEFAULT_STATUSES_SUCCESS = 'MY_WORKSPACE_LOAD_DEFAULT_STATUSES_SUCCESS';
export const MY_WORKSPACE_LOAD_DEFAULT_STATUSES_FAILURE = 'MY_WORKSPACE_LOAD_DEFAULT_STATUSES_FAILURE';

export const MY_WORKSPACE_MY_TASKS_BY_STATUS_REQUEST = 'MY_WORKSPACE_MY_TASKS_BY_STATUS_REQUEST';
export const MY_WORKSPACE_MY_TASKS_BY_STATUS_SUCCESS = 'MY_WORKSPACE_MY_TASKS_BY_STATUS_SUCCESS';
export const MY_WORKSPACE_MY_TASKS_BY_STATUS_FAILURE = 'MY_WORKSPACE_MY_TASKS_BY_STATUS_FAILURE';

// Project Tag Actions
export const SEARCH_PROJECT_TAGS_REQUEST = 'SEARCH_PROJECT_TAGS_REQUEST';
export const SEARCH_PROJECT_TAGS_SUCCESS = 'SEARCH_PROJECT_TAGS_SUCCESS';
export const SEARCH_PROJECT_TAGS_FAILURE = 'SEARCH_PROJECT_TAGS_FAILURE';
export const CREATE_PROJECT_TAG_REQUEST = 'CREATE_PROJECT_TAG_REQUEST';
export const CREATE_PROJECT_TAG_SUCCESS = 'CREATE_PROJECT_TAG_SUCCESS';
export const CREATE_PROJECT_TAG_FAILURE = 'CREATE_PROJECT_TAG_FAILURE';
export const UPDATE_PROJECT_TAG_REQUEST = 'UPDATE_PROJECT_TAG_REQUEST';
export const UPDATE_PROJECT_TAG_SUCCESS = 'UPDATE_PROJECT_TAG_SUCCESS';
export const UPDATE_PROJECT_TAG_FAILURE = 'UPDATE_PROJECT_TAG_FAILURE';

// Location task user filters
export const LIST_LOCATION_TASK_USER_FILTERS_REQUEST = 'LIST_LOCATION_TASK_USER_FILTERS_REQUEST';
export const LIST_LOCATION_TASK_USER_FILTERS_SUCCESS = 'LIST_LOCATION_TASK_USER_FILTERS_SUCCESS';
export const LIST_LOCATION_TASK_USER_FILTERS_FAILURE = 'LIST_LOCATION_TASK_USER_FILTERS_FAILURE';
export const SAVE_LOCATION_TASK_USER_FILTERS_REQUEST = 'SAVE_LOCATION_TASK_USER_FILTERS_REQUEST';
export const SAVE_LOCATION_TASK_USER_FILTERS_SUCCESS = 'SAVE_LOCATION_TASK_USER_FILTERS_SUCCESS';
export const SAVE_LOCATION_TASK_USER_FILTERS_FAILURE = 'SAVE_LOCATION_TASK_USER_FILTERS_FAILURE';

// mfa actions
export const MFA_VERIFY_AUTHENTICATOR_REQUEST = 'MFA_VERIFY_AUTHENTICATOR_REQUEST';
export const MFA_VERIFY_AUTHENTICATOR_SUCCESS = 'MFA_VERIFY_AUTHENTICATOR_SUCCESS';
export const MFA_VERIFY_AUTHENTICATOR_FAILURE = 'MFA_VERIFY_AUTHENTICATOR_FAILURE';
export const MFA_LOGIN_REQUEST = 'MFA_LOGIN_REQUEST';
export const MFA_LOGIN_SUCCESS = 'MFA_LOGIN_SUCCESS';
export const MFA_LOGIN_FAILURE = 'MFA_LOGIN_FAILURE';
export const MFA_RESET_REQUEST = 'MFA_RESET_REQUEST';
export const MFA_RESET_SUCCESS = 'MFA_RESET_SUCCESS';
export const MFA_RESET_FAILURE = 'MFA_RESET_FAILURE';
export const MFA_DISABLE_REQUEST = 'MFA_DISABLE_REQUEST';
export const MFA_DISABLE_SUCCESS = 'MFA_DISABLE_SUCCESS';
export const MFA_DISABLE_FAILURE = 'MFA_DISABLE_FAILURE';

export const LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_REQUEST = 'LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_REQUEST';
export const LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_SUCCESS = 'LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_SUCCESS';
export const LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_FAILURE = 'LOAD_PROJECT_TASKS_AND_MILESTONES_COMPLETIONS_GRAPH_FAILURE';
